import React from "react";
import styles from "./Illustration.module.scss";

interface Props extends React.ComponentPropsWithoutRef<"svg"> { }

const Illustration = (props: Props) => {
  return (
    <svg
      width="712"
      height="231"
      viewBox="0 0 712 231"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M706.2 176.4H654.7C652.4 176.4 650.5 174.5 650.5 172.2V61.2C650.5 58.9 652.4 57 654.7 57H706.2C708.5 57 710.4 58.9 710.4 61.2V172.1C710.4 174.5 708.5 176.4 706.2 176.4Z"
        fill="white"
      />
      <path
        d="M706.2 177.4H654.7C651.8 177.4 649.5 175 649.5 172.2V61.2C649.5 58.3 651.9 56 654.7 56H706.2C709.1 56 711.4 58.4 711.4 61.2V172.1C711.4 175 709.1 177.4 706.2 177.4ZM654.7 58C652.9 58 651.5 59.5 651.5 61.2V172.1C651.5 173.9 653 175.3 654.7 175.3H706.2C708 175.3 709.4 173.8 709.4 172.1V61.2C709.4 59.4 707.9 58 706.2 58H654.7Z"
        fill="#231F20"
      />
      <path d="M685.7 62.6H666.6V64.6H685.7V62.6Z" fill="#231F20" />
      <path d="M694.3 62.5H689V64.7H694.3V62.5Z" fill="#231F20" />
      <path d="M681.9 167.7H679V169.7H681.9V167.7Z" fill="#231F20" />
      <path d="M704 72.2H657V83.2H704V72.2Z" fill="#5B5A5A" />
      <path d="M665.9 74.2H659.3V76.2H665.9V74.2Z" fill="#231F20" />
      <path d="M665.9 76.5H659.3V78.5H665.9V76.5Z" fill="#231F20" />
      <path d="M665.9 78.9H659.3V80.9H665.9V78.9Z" fill="#231F20" />
      <path d="M701.1 76.5H677V78.5H701.1V76.5Z" fill="#231F20" />
      <g id={styles.phone}>
        <path id="phoneBox" d="M673.3 89.4H659.8V100.1H673.3V89.4Z" fill="#FEDF0D" />
        <path
          d="M704.2 103.1H656.8V86.4H704.2V103.1ZM658.7 101.1H702.1V88.4H658.7V101.1Z"
          fill="#B0BBBD"
        />
        <path d="M699.2 90.2H685.6V92.2H699.2V90.2Z" fill="#5B5A5A" />
        <path d="M699.1 93.7H676.9V95.7H699.1V93.7Z" fill="#B0BBBD" />
        <path d="M699.1 97.2H676.9V99.2H699.1V97.2Z" fill="#B0BBBD" />
      </g>
      <path
        d="M707.2 160.4H653.7V69.2H707.2V160.4ZM655.7 158.4H705.2V71.2H655.7V158.4Z"
        fill="#231F20"
      />
      <path d="M673.3 107.1H659.8V117.8H673.3V107.1Z" fill="#FEDF0D" />
      <path
        d="M704.2 120.7H656.8V104H704.2V120.7ZM658.7 118.7H702.1V106H658.7V118.7Z"
        fill="#B0BBBD"
      />
      <path d="M699.2 107.9H685.6V109.9H699.2V107.9Z" fill="#5B5A5A" />
      <path d="M699.1 111.4H676.9V113.4H699.1V111.4Z" fill="#B0BBBD" />
      <path d="M699.1 114.9H676.9V116.9H699.1V114.9Z" fill="#B0BBBD" />
      <path d="M673.3 124.6H659.8V135.3H673.3V124.6Z" fill="#FEDF0D" />
      <path
        d="M704.2 138.4H656.8V121.7H704.2V138.4ZM658.7 136.4H702.1V123.7H658.7V136.4Z"
        fill="#B0BBBD"
      />
      <path d="M699.2 125.5H685.6V127.5H699.2V125.5Z" fill="#5B5A5A" />
      <path d="M699.1 129.1H676.9V131.1H699.1V129.1Z" fill="#B0BBBD" />
      <path d="M699.1 132.5H676.9V134.5H699.1V132.5Z" fill="#B0BBBD" />
      <path
        d="M704.2 156.1H656.8V139.4H704.2V156.1ZM658.7 154.1H702.1V141.4H658.7V154.1Z"
        fill="#B0BBBD"
      />
      <path d="M673.2 142.4H659.7V153.1H673.2V142.4Z" fill="#FEDF0D" />
      <path d="M699.2 143.2H685.6V145.2H699.2V143.2Z" fill="#5B5A5A" />
      <path d="M699.1 146.7H676.9V148.7H699.1V146.7Z" fill="#B0BBBD" />
      <path d="M699.1 150.2H676.9V152.2H699.1V150.2Z" fill="#B0BBBD" />
      <path
        d="M605.6 141.6H591.3L598.4 129.2L605.6 141.6ZM594.8 139.6H602.1L598.4 133.2L594.8 139.6Z"
        fill="#231F20"
      />
      <path d="M599.4 140.6H597.4V145.6H599.4V140.6Z" fill="#231F20" />
      <path d="M599.5 120.9H597.5V124.3H599.5V120.9Z" fill="#231F20" />
      <path
        d="M593.067 123.341L592.067 125.074L595.012 126.773L596.011 125.041L593.067 123.341Z"
        fill="#231F20"
      />
      <path
        d="M594.985 128.501L592.04 130.2L593.04 131.933L595.985 130.233L594.985 128.501Z"
        fill="#231F20"
      />
      <path
        d="M601.829 128.554L600.829 130.286L603.773 131.986L604.773 130.254L601.829 128.554Z"
        fill="#231F20"
      />
      <path
        d="M603.787 123.522L600.842 125.221L601.842 126.953L604.786 125.254L603.787 123.522Z"
        fill="#231F20"
      />
      <g id={styles.lightbulb}>
        <path
          d="M49.9003 69.8C49.9003 57.8 40.2003 48 28.1003 48C16.1003 48 6.30029 57.7 6.30029 69.8C6.30029 77.7 16.9003 99.1 16.9003 99.1H39.2003C39.3003 99.1 49.9003 77.7 49.9003 69.8Z"
          fill="white"
        />
      </g>
      <path
        d="M48.1595 85.361L47.4189 87.2188L50.2056 88.3297L50.9462 86.4719L48.1595 85.361Z"
        fill="#231E21"
      />
      <path
        d="M50.1782 79.8396L49.5142 81.7262L52.3441 82.7222L53.0081 80.8356L50.1782 79.8396Z"
        fill="#231E21"
      />
      <path
        d="M51.9124 74.352L51.3892 76.2824L54.2848 77.0672L54.808 75.1368L51.9124 74.352Z"
        fill="#231E21"
      />
      <path
        d="M52.7004 68.7632L52.584 70.7598L55.5789 70.9344L55.6953 68.9378L52.7004 68.7632Z"
        fill="#231E21"
      />
      <path
        d="M54.9734 62.6299L52.0322 63.2215L52.4266 65.1823L55.3678 64.5907L54.9734 62.6299Z"
        fill="#231E21"
      />
      <path
        d="M52.741 56.6664L50.0122 57.9129L50.8432 59.7321L53.572 58.4856L52.741 56.6664Z"
        fill="#231E21"
      />
      <path
        d="M49.4 51.4529L47.0249 53.2859L48.2469 54.8693L50.622 53.0363L49.4 51.4529Z"
        fill="#231E21"
      />
      <path
        d="M44.7959 47.1056L42.8945 49.4261L44.4415 50.6937L46.3429 48.3732L44.7959 47.1056Z"
        fill="#231E21"
      />
      <path
        d="M39.3862 43.9181L38.0605 46.6094L39.8547 47.4932L41.1804 44.8019L39.3862 43.9181Z"
        fill="#231E21"
      />
      <path
        d="M33.3824 42.0266L32.7056 44.9492L34.654 45.4004L35.3308 42.4778L33.3824 42.0266Z"
        fill="#231E21"
      />
      <path d="M29.1001 41.5H27.1001V44.5H29.1001V41.5Z" fill="#231E21" />
      <path
        d="M22.8268 42.0205L20.8784 42.4717L21.5552 45.3943L23.5036 44.9431L22.8268 42.0205Z"
        fill="#231E21"
      />
      <path
        d="M16.8499 43.9307L15.0557 44.8145L16.3814 47.5058L18.1756 46.622L16.8499 43.9307Z"
        fill="#231E21"
      />
      <path
        d="M11.4504 47.1262L9.90283 48.3932L11.8033 50.7146L13.3509 49.4476L11.4504 47.1262Z"
        fill="#231E21"
      />
      <path
        d="M6.96781 51.4871L5.74561 53.0703L8.12041 54.9036L9.34261 53.3204L6.96781 51.4871Z"
        fill="#231E21"
      />
      <path
        d="M3.52614 56.7709L2.69434 58.5897L5.42254 59.8374L6.25434 58.0186L3.52614 56.7709Z"
        fill="#231E21"
      />
      <path
        d="M1.33396 62.6035L0.938965 64.5641L3.87986 65.1566L4.27486 63.196L1.33396 62.6035Z"
        fill="#231E21"
      />
      <path
        d="M3.53738 68.7049L0.54248 68.8777L0.657656 70.8743L3.65256 70.7015L3.53738 68.7049Z"
        fill="#231E21"
      />
      <path
        d="M4.36581 74.2558L1.47021 75.0406L1.99341 76.971L4.88901 76.1862L4.36581 74.2558Z"
        fill="#231E21"
      />
      <path
        d="M6.07404 79.8647L3.24414 80.8607L3.90814 82.7473L6.73804 81.7513L6.07404 79.8647Z"
        fill="#231E21"
      />
      <path
        d="M8.13173 85.4223L5.34473 86.5329L6.08513 88.3909L8.87213 87.2803L8.13173 85.4223Z"
        fill="#231E21"
      />
      <path d="M42.4004 98.1H13.9004V100.1H42.4004V98.1Z" fill="#231E21" />
      <path d="M42.4004 103.7H13.9004V105.7H42.4004V103.7Z" fill="#231E21" />
      <path d="M42.4004 109.4H13.9004V111.4H42.4004V109.4Z" fill="#231E21" />
      <path d="M18.1001 99.1H16.1001V110.4H18.1001V99.1Z" fill="#231E21" />
      <path d="M36.5001 113.4H19.6001V115.4H36.5001V113.4Z" fill="#231E21" />
      <path
        d="M18.9807 74.7071L17.0103 75.0497L21.2242 99.2856L23.1946 98.943L18.9807 74.7071Z"
        fill="#231E21"
      />
      <path
        d="M37.7384 74.7L33.522 98.9359L35.4924 99.2787L39.7088 75.0428L37.7384 74.7Z"
        fill="#231E21"
      />
      <path
        d="M25.6006 76.5H23.6006C23.6006 76.2 23.1006 76.2 23.1006 76.5H21.1006C21.1006 75.3 22.1006 74.2 23.4006 74.2C24.7006 74.2 25.6006 75.3 25.6006 76.5Z"
        fill="#231E21"
      />
      <path
        d="M20.8005 78.6C19.6005 78.6 18.5005 77.6 18.5005 76.3H20.5005C20.5005 76.6 21.0005 76.6 21.0005 76.3H23.0005C23.0005 77.6 22.0005 78.6 20.8005 78.6Z"
        fill="#231E21"
      />
      <path
        d="M25.8005 78.6C24.6005 78.6 23.5005 77.6 23.5005 76.3H25.5005C25.5005 76.6 26.0005 76.6 26.0005 76.3H28.0005C28.1005 77.6 27.1005 78.6 25.8005 78.6Z"
        fill="#231E21"
      />
      <path
        d="M30.9006 78.6C29.7006 78.6 28.6006 77.6 28.6006 76.3H30.6006C30.6006 76.6 31.1006 76.6 31.1006 76.3H33.1006C33.1006 77.6 32.1006 78.6 30.9006 78.6Z"
        fill="#231E21"
      />
      <path
        d="M35.9006 78.6C34.7006 78.6 33.6006 77.6 33.6006 76.3H35.6006C35.6006 76.6 36.1006 76.6 36.1006 76.3H38.1006C38.2006 77.6 37.2006 78.6 35.9006 78.6Z"
        fill="#231E21"
      />
      <path
        d="M30.6006 76.5H28.6006C28.6006 76.2 28.1006 76.2 28.1006 76.5H26.1006C26.1006 75.3 27.1006 74.2 28.4006 74.2C29.6006 74.3 30.6006 75.3 30.6006 76.5Z"
        fill="#231E21"
      />
      <path
        d="M35.7007 76.5H33.7007C33.7007 76.2 33.2007 76.2 33.2007 76.5H31.2007C31.2007 75.3 32.2007 74.2 33.5007 74.2C34.7007 74.3 35.7007 75.3 35.7007 76.5Z"
        fill="#231E21"
      />
      <path
        d="M13 69.6H11C11 60.5 18.4 53 27.6 53V55C19.5 55 13 61.6 13 69.6Z"
        fill="white"
      />
      <path
        d="M19.5005 26.3L18.5005 24.7C18.5005 24.7 18.6005 24.6 18.8005 24.5C18.9005 24.4 19.0005 24.4 19.1005 24.3C19.2005 24.2 19.3005 24.1 19.4005 24.1C19.5005 24 19.6005 23.9 19.6005 23.8C19.7005 23.7 19.7005 23.6 19.8005 23.5C19.9005 23.3 20.0005 23.2 20.0005 23.2L21.6005 24.2C21.6005 24.2 21.5005 24.4 21.4005 24.6C21.3005 24.7 21.2005 24.8 21.1005 25C21.0005 25.1 20.9005 25.3 20.7005 25.4C20.6005 25.5 20.4005 25.7 20.3005 25.8C20.2005 25.9 20.0005 26 19.9005 26.1C19.7005 26.2 19.5005 26.3 19.5005 26.3Z"
        fill="#231E21"
      />
      <path
        d="M13.8003 26.3L14.8003 24.7C14.8003 24.7 14.8003 24.7 14.9003 24.7C14.9003 24.7 15.0003 24.8 15.1003 24.8C15.2003 24.8 15.3003 24.9 15.4003 24.9C15.5003 24.9 15.6003 25 15.8003 25C16.0003 25.1 16.3003 25.1 16.5003 25.1C16.7003 25.1 16.8003 25.1 16.8003 25.1V27C16.8003 27 16.6003 27 16.3003 27C16.0003 27 15.6003 26.9 15.3003 26.8C15.1003 26.8 14.9003 26.7 14.8003 26.6C14.6003 26.5 14.5003 26.5 14.4003 26.4C13.9003 26.4 13.8003 26.3 13.8003 26.3Z"
        fill="#231E21"
      />
      <path
        d="M10.9003 21.4H12.8003C12.8003 21.4 12.8003 21.5 12.8003 21.7C12.8003 21.9 12.8003 22.1 12.9003 22.4C12.9003 22.5 13.0003 22.6 13.0003 22.8C13.0003 22.9 13.1003 23 13.1003 23.1C13.1003 23.2 13.2003 23.3 13.2003 23.3V23.4L11.6003 24.4C11.6003 24.4 11.5003 24.2 11.4003 24C11.3003 23.9 11.3003 23.7 11.2003 23.6C11.1003 23.4 11.1003 23.3 11.0003 23.1C10.9003 22.7 10.8003 22.4 10.8003 22.1C10.9003 21.5 10.9003 21.4 10.9003 21.4Z"
        fill="#231E21"
      />
      <path
        d="M13.8002 16.4L14.8002 18C14.8002 18 14.7002 18.1 14.5002 18.2C14.4002 18.3 14.3002 18.3 14.2002 18.4C14.1002 18.5 14.0002 18.6 13.9002 18.6C13.8002 18.7 13.7002 18.8 13.7002 18.9C13.6002 19 13.6002 19.1 13.5002 19.2C13.4002 19.4 13.3002 19.5 13.3002 19.5L11.7002 18.5C11.7002 18.5 11.8002 18.3 11.9002 18.1C12.0002 18 12.1002 17.9 12.2002 17.7C12.3002 17.6 12.4002 17.4 12.6002 17.3C12.7002 17.2 12.9002 17 13.0002 16.9C13.1002 16.8 13.3002 16.7 13.4002 16.6C13.6002 16.5 13.8002 16.4 13.8002 16.4Z"
        fill="#231E21"
      />
      <path
        d="M19.5005 16.4L18.5005 18C18.5005 18 18.5005 18 18.4005 18C18.4005 18 18.3005 17.9 18.2005 17.9C18.1005 17.9 18.0005 17.8 17.9005 17.8C17.8005 17.8 17.7005 17.7 17.5005 17.7C17.3005 17.6 17.0005 17.6 16.8005 17.6C16.6005 17.6 16.5005 17.6 16.5005 17.6V15.7C16.5005 15.7 16.7005 15.7 17.0005 15.7C17.3005 15.7 17.7005 15.8 18.0005 15.9C18.2005 15.9 18.4005 16 18.5005 16.1C18.7005 16.2 18.8005 16.2 18.9005 16.3C19.4005 16.3 19.5005 16.4 19.5005 16.4Z"
        fill="#231E21"
      />
      <path
        d="M22.4001 21.4H20.5001C20.5001 21.4 20.5001 21.3 20.5001 21.1C20.5001 20.9 20.5001 20.7 20.4001 20.4C20.4001 20.3 20.3001 20.2 20.3001 20C20.3001 19.9 20.2001 19.8 20.2001 19.7C20.2001 19.6 20.1001 19.5 20.1001 19.5V19.4L21.7001 18.4C21.7001 18.4 21.8001 18.6 21.9001 18.8C22.0001 18.9 22.0001 19.1 22.1001 19.2C22.2001 19.4 22.2001 19.5 22.3001 19.7C22.4001 20.1 22.5001 20.4 22.5001 20.7C22.4001 21.2 22.4001 21.4 22.4001 21.4Z"
        fill="#231E21"
      />
      <path d="M365.8 142.955V53.3551H355.9V142.955H365.8Z" fill="white" />
      <path
        d="M366.8 143.9H354.9V52.3H366.8V143.9ZM356.9 141.9H364.8V54.3H356.9V141.9Z"
        fill="#231E21"
      />
      <path
        d="M364.2 158.1H357.5C356.1 158.1 354.9 157 354.9 155.5V151.8C354.9 150.4 356 149.2 357.5 149.2H364.2C365.6 149.2 366.8 150.3 366.8 151.8V155.5C366.8 156.9 365.7 158.1 364.2 158.1ZM357.5 151.2C357.2 151.2 356.9 151.5 356.9 151.8V155.5C356.9 155.8 357.2 156.1 357.5 156.1H364.2C364.5 156.1 364.8 155.8 364.8 155.5V151.8C364.8 151.5 364.5 151.2 364.2 151.2H357.5Z"
        fill="#231E21"
      />
      <path
        d="M355.063 145.113V152.813H366.663V145.113H355.063Z"
        fill="#5B5B5B"
      />
      <path d="M361.9 54.1H359.9V143.7H361.9V54.1Z" fill="#231E21" />
      <path
        d="M366.8 54.3H354.9V50L360.8 37.9L366.7 50V54.3H366.8ZM356.9 52.3H364.8V50.4L360.9 42.4L357 50.4V52.3H356.9Z"
        fill="#231E21"
      />
      <path
        d="M564.9 51.8V170.1C564.9 183.8 553.8 194.9 540.1 194.9C526.4 194.9 515.3 183.8 515.3 170.1H526.3C526.3 177.7 532.5 183.9 540.1 183.9C547.7 183.9 553.9 177.7 553.9 170.1V51.8H564.9Z"
        fill="white"
      />
      <path d="M560.4 58.5H558.4V63H560.4V58.5Z" fill="#1D1912" />
      <path d="M560.4 69.8H558.4V74.3H560.4V69.8Z" fill="#1D1912" />
      <path d="M560.4 81H558.4V85.5H560.4V81Z" fill="#1D1912" />
      <path d="M560.4 92.2H558.4V96.7H560.4V92.2Z" fill="#1D1912" />
      <path d="M560.4 103.4H558.4V107.9H560.4V103.4Z" fill="#1D1912" />
      <path d="M560.4 114.7H558.4V119.2H560.4V114.7Z" fill="#1D1912" />
      <path d="M560.4 125.9H558.4V130.4H560.4V125.9Z" fill="#1D1912" />
      <path d="M560.4 137.1H558.4V141.6H560.4V137.1Z" fill="#1D1912" />
      <path d="M560.4 148.3H558.4V152.8H560.4V148.3Z" fill="#1D1912" />
      <path d="M560.4 159.6H558.4V164.1H560.4V159.6Z" fill="#1D1912" />
      <path
        d="M560.4 170.8V171.5C560.4 171.9 560.3 172.5 560.2 173.1C560.1 173.7 560 174.3 559.9 174.7L559.7 175.3L557.8 174.8L558 174.1C558.1 173.7 558.2 173.2 558.3 172.7C558.4 172.2 558.5 171.7 558.5 171.3V170.5L560.4 170.8Z"
        fill="#1D1912"
      />
      <path
        d="M556.601 181.8L556.201 182.4C555.901 182.8 555.501 183.3 555.101 183.7C554.701 184.1 554.301 184.6 553.901 184.9L553.401 185.3L552.101 183.8L552.601 183.3C552.901 183 553.301 182.6 553.601 182.3C554.001 181.9 554.301 181.5 554.501 181.2L554.901 180.6L556.601 181.8Z"
        fill="#1D1912"
      />
      <path
        d="M547.401 189L546.701 189.2C546.301 189.4 545.701 189.5 545.101 189.7C544.501 189.9 543.901 190 543.501 190.1L542.901 190.2L542.601 188.2L543.301 188.1C543.701 188.1 544.201 187.9 544.701 187.8C545.201 187.7 545.701 187.5 546.001 187.4L546.701 187.1L547.401 189Z"
        fill="#1D1912"
      />
      <path
        d="M536.3 187.9L535.8 189.8L534.8 189.5C534.4 189.4 533.9 189.3 533.5 189.1C533.3 189 533.2 189 533 188.9C532.6 188.8 532.3 188.6 532 188.5L531.4 188.2L532.3 186.4L532.9 186.7C533.1 186.8 533.4 186.9 533.7 187C533.9 187.1 534.1 187.1 534.3 187.2C534.7 187.3 535 187.4 535.4 187.5L536.3 187.9Z"
        fill="#1D1912"
      />
      <path
        d="M527.1 182.9L525.6 184.2L525 183.6C524.7 183.3 524.4 182.9 524 182.4C523.3 181.5 522.7 180.5 522.7 180.5L524.4 179.5C524.4 179.5 524.9 180.4 525.6 181.2C525.9 181.6 526.2 181.9 526.4 182.2L527.1 182.9Z"
        fill="#1D1912"
      />
      <path
        d="M522.2 173.6L520.2 173.9L520 172.9C519.9 172.5 519.9 172 519.9 171.5V171C519.9 170.6 519.9 170.3 519.9 170V169.3H521.9V170C521.9 170.2 521.9 170.6 521.9 170.9V171.5C521.9 171.9 522 172.3 522 172.6L522.2 173.6Z"
        fill="#1D1912"
      />
      <path
        d="M343.9 107.3H332.9V40.3C332.9 19.9 349.5 3.3 369.9 3.3C390.3 3.3 406.9 19.9 406.9 40.3V87.1H395.9V40.3C395.9 26 384.2 14.3 369.9 14.3C355.6 14.3 343.9 26 343.9 40.3V107.3Z"
        fill="white"
      />
      <path
        d="M339.2 107.3H337.5V100.3H339.2V107.3ZM339.2 93.3H337.5V86.3H339.2V93.3ZM402.2 87.1H400.5V84.4H402.2V87.1ZM339.2 79.3H337.5V72.3H339.2V79.3ZM402.2 77.4H400.5V70.4H402.2V77.4ZM339.2 65.3H337.5V58.3H339.2V65.3ZM402.2 63.4H400.5V56.4H402.2V63.4ZM339.2 51.3H337.5V44.3H339.2V51.3ZM402.2 49.4H400.5V42.4H402.2V49.4ZM339.4 37.4L337.7 37.2C337.9 34.8 338.4 32.5 339.2 30.2L340.8 30.7C340 32.9 339.6 35.1 339.4 37.4ZM400.1 35.5C399.7 33.3 399.1 31.1 398.3 29L399.9 28.4C400.8 30.6 401.4 32.9 401.8 35.3L400.1 35.5ZM343.6 24.6L342.1 23.7C343.3 21.7 344.8 19.7 346.5 18L347.7 19.2C346.2 20.8 344.8 22.6 343.6 24.6ZM395.1 23C393.8 21.1 392.3 19.4 390.7 17.9L391.9 16.7C393.7 18.3 395.2 20.2 396.6 22.1L395.1 23ZM352.9 14.8L352 13.4C354 12.1 356.1 11 358.4 10.1L359 11.7C356.8 12.5 354.8 13.5 352.9 14.8ZM385.2 13.8C383.2 12.7 381.1 11.7 379 11.1L379.5 9.5C381.8 10.2 384 11.2 386.1 12.4L385.2 13.8ZM365.5 10L365.3 8.30001C367.7 8.00001 370.1 7.90001 372.5 8.10001L372.4 9.80001C370.1 9.60001 367.8 9.6 365.5 10Z"
        fill="#231F20"
      />
      <path d="M218.9 194.5H179.4V139.6L218.9 194.5Z" fill="#C7D2D4" />
      <path d="M202 185.7H187.7V165.9L202 185.7Z" fill="white" />
      <path d="M184 189.7H179.4V191.4H184V189.7Z" fill="#231F20" />
      <path d="M182.3 185.9H179.4V187.6H182.3V185.9Z" fill="#231F20" />
      <path d="M184 182.1H179.4V183.8H184V182.1Z" fill="#231F20" />
      <path d="M182.3 178.4H179.4V180.1H182.3V178.4Z" fill="#231F20" />
      <path d="M184 174.6H179.4V176.3H184V174.6Z" fill="#231F20" />
      <path d="M182.3 170.8H179.4V172.5H182.3V170.8Z" fill="#231F20" />
      <path d="M184 167.1H179.4V168.8H184V167.1Z" fill="#231F20" />
      <path d="M182.3 163.3H179.4V165H182.3V163.3Z" fill="#231F20" />
      <path d="M184 159.6H179.4V161.3H184V159.6Z" fill="#231F20" />
      <path d="M182.3 155.8H179.4V157.5H182.3V155.8Z" fill="#231F20" />
      <path d="M184 152H179.4V153.7H184V152Z" fill="#231F20" />
      <path d="M182.3 148.3H179.4V150H182.3V148.3Z" fill="#231F20" />
      <path d="M442.6 113.5H440.9V140.4H442.6V113.5Z" fill="#231F20" />
      <path
        d="M438.243 114.673L445.343 114.673L445.343 111.573L438.243 111.573L438.243 114.673Z"
        fill="#C7D2D4"
      />
      <path
        d="M447.7 111.7V84C447.7 83.1 447 82.4 446.1 82.4H437.5C436.6 82.4 435.9 83.1 435.9 84V111.8H447.7V111.7Z"
        fill="white"
      />
      <path d="M447.7 110.9H435.9V112.6H447.7V110.9Z" fill="#231F20" />
      <path d="M444.5 85.3H442.8V108.3H444.5V85.3Z" fill="#231F20" />
      <path d="M440.701 85.3H439V108.3H440.701V85.3Z" fill="#231F20" />
      <path
        d="M441.8 139L445.1 143.5L444 150.4H439.6L438.5 143.5L441.8 139ZM443.3 143.9L441.8 141.9L440.3 143.9L441 148.7H442.5L443.3 143.9Z"
        fill="#231F20"
      />
      <path
        d="M404.5 115.4H398.3V104.7H404.5V115.4ZM400 113.7H402.8V106.4H400V113.7Z"
        fill="#231F20"
      />
      <path d="M402.2 86.7H400.5V105.5H402.2V86.7Z" fill="#231F20" />
      <path
        d="M401.4 123.4C399.5 123.4 397.9 121.8 397.9 119.9H399.6C399.6 120.9 400.4 121.7 401.4 121.7C402.4 121.7 403.2 120.9 403.2 119.9C403.2 118.9 402.4 118.1 401.4 118.1H400.5V114.5H402.2V116.5C403.7 116.9 404.8 118.2 404.8 119.9C404.8 121.9 403.3 123.4 401.4 123.4Z"
        fill="#231F20"
      />
      <g id={styles.puzzle}>
        <path
          d="M401.4 158.7C398.7 158.7 396.5 156.5 396.5 153.8V153.7H390.4C389.1 153.7 388 152.6 388 151.3V142.9L389.1 143.3C389.5 143.4 389.8 143.5 390.2 143.5C392 143.5 393.4 142.1 393.4 140.3C393.4 138.5 392 137.1 390.2 137.1C389.8 137.1 389.4 137.2 389.1 137.3L388 137.7V129.3C388 128 389.1 126.9 390.4 126.9H396.5C396.5 126.8 396.5 126.7 396.5 126.5C396.5 123.8 398.7 121.6 401.4 121.6C404.1 121.6 406.3 123.8 406.3 126.5C406.3 126.6 406.3 126.7 406.3 126.9H412.4C413.7 126.9 414.8 128 414.8 129.3V137.7L413.7 137.3C413.3 137.2 413 137.1 412.6 137.1C410.8 137.1 409.4 138.5 409.4 140.3C409.4 142.1 410.8 143.5 412.6 143.5C413 143.5 413.4 143.4 413.7 143.3L414.8 142.9V151.3C414.8 152.6 413.7 153.7 412.4 153.7H406.3V153.8C406.3 156.5 404.1 158.7 401.4 158.7ZM389.7 145.2V151.3C389.7 151.7 390 152 390.4 152H398.5L398.2 153.1C398.1 153.4 398.1 153.6 398.1 153.9C398.1 155.7 399.5 157.1 401.3 157.1C403.1 157.1 404.5 155.7 404.5 153.9C404.5 153.6 404.5 153.4 404.4 153.1L404.1 152H412.2C412.6 152 412.9 151.7 412.9 151.3V145.2C412.7 145.2 412.5 145.2 412.3 145.2C409.6 145.2 407.4 143 407.4 140.3C407.4 137.6 409.6 135.4 412.3 135.4C412.5 135.4 412.7 135.4 412.9 135.4V129.3C412.9 128.9 412.6 128.6 412.2 128.6H403.9L404.2 127.5C404.3 127.2 404.3 126.9 404.3 126.5C404.3 124.7 402.9 123.3 401.1 123.3C399.3 123.3 397.9 124.7 397.9 126.5C397.9 126.8 397.9 127.1 398 127.5L398.3 128.6H390C389.6 128.6 389.3 128.9 389.3 129.3V135.4C389.5 135.4 389.7 135.4 389.9 135.4C392.6 135.4 394.8 137.6 394.8 140.3C394.8 143 392.6 145.2 389.9 145.2C390.1 145.2 389.9 145.2 389.7 145.2Z"
          fill="#231F20"
        />
        <path
          d="M403.6 135.6L402.5 135.2L401.8 136.3C401.3 136.2 400.9 136.3 400.4 136.4L399.6 135.4L398.5 135.9L398.8 137.1C398.5 137.4 398.2 137.7 398 138L396.8 137.8L396.4 138.9L397.4 139.6C397.3 140.1 397.3 140.5 397.4 141L396.4 141.7L396.9 142.8L398.1 142.6C398.4 143 398.7 143.3 399.1 143.6L398.9 144.8L400 145.2L400.7 144.2C401.2 144.3 401.6 144.3 402.1 144.2L402.8 145.2L403.9 144.7L403.7 143.5C404.1 143.2 404.5 142.8 404.7 142.4L405.9 142.5L406.3 141.4L405.2 140.7C405.3 140.2 405.2 139.8 405.1 139.3L406.1 138.5L405.6 137.4L404.4 137.7C404.1 137.3 403.8 137 403.4 136.8L403.6 135.6Z"
          fill="#5B5B5B"
        />
        <path
          d="M401.9 138.7C402.7 139 403.1 139.9 402.8 140.7C402.5 141.5 401.6 141.9 400.8 141.6C400 141.3 399.6 140.4 399.9 139.6C400.2 138.9 401.1 138.4 401.9 138.7Z"
          fill="white"
        />
      </g>
      <path d="M467.7 73.7H466V76.4H467.7V73.7Z" fill="#231F20" />
      <path d="M467.7 68.4H466V71.1H467.7V68.4Z" fill="#231F20" />
      <path d="M473.5 63.6H470.8V65.3H473.5V63.6Z" fill="#231F20" />
      <path d="M478.8 63.6H476.1V65.3H478.8V63.6Z" fill="#231F20" />
      <path d="M483.6 68.4H481.9V71.1H483.6V68.4Z" fill="#231F20" />
      <path d="M483.6 73.7H481.9V76.4H483.6V73.7Z" fill="#231F20" />
      <path d="M478.8 79.5H476.1V81.2H478.8V79.5Z" fill="#231F20" />
      <path d="M473.5 79.5H470.8V81.2H473.5V79.5Z" fill="#231F20" />
      <path d="M467.7 63.2H466V65.7H467.7V63.2Z" fill="#231F20" />
      <path d="M468.1 63.6H465.6V65.3H468.1V63.6Z" fill="#231F20" />
      <path d="M484 63.6H481.5V65.3H484V63.6Z" fill="#231F20" />
      <path d="M483.6 63.2H481.9V65.7H483.6V63.2Z" fill="#231F20" />
      <path d="M483.6 79.1H481.9V81.6H483.6V79.1Z" fill="#231F20" />
      <path d="M484 79.5H481.5V81.2H484V79.5Z" fill="#231F20" />
      <path d="M468.1 79.5H465.6V81.2H468.1V79.5Z" fill="#231F20" />
      <path d="M467.7 79.1H466V81.6H467.7V79.1Z" fill="#231F20" />
      <path d="M484.7 62.5H480.7V66.5H484.7V62.5Z" fill="white" />
      <path
        d="M485.6 67.3H479.9V61.6H485.6V67.3ZM481.6 65.6H483.9V63.3H481.6V65.6Z"
        fill="#231F20"
      />
      <path d="M484.7 78.3H480.7V82.3H484.7V78.3Z" fill="white" />
      <path
        d="M485.6 83.2H479.9V77.5H485.6V83.2ZM481.6 81.5H483.9V79.2H481.6V81.5Z"
        fill="#231F20"
      />
      <path d="M468.9 78.3H464.9V82.3H468.9V78.3Z" fill="white" />
      <path
        d="M469.7 83.2H464V77.5H469.7V83.2ZM465.7 81.5H468V79.2H465.7V81.5Z"
        fill="#231F20"
      />
      <path d="M468.9 62.5H464.9V66.5H468.9V62.5Z" fill="white" />
      <path
        d="M469.7 67.3H464V61.6H469.7V67.3ZM465.7 65.6H468V63.3H465.7V65.6Z"
        fill="#231F20"
      />
      <path d="M440.9 45.2H439.2V54.4H440.9V45.2Z" fill="#231F20" />
      <path d="M444.6 49H435.4V50.7H444.6V49Z" fill="#231F20" />
      <path
        d="M488.5 29.6V24.3L493.1 26.9L497.7 29.6L493.1 32.2L488.5 34.9V29.6Z"
        fill="#C7D2D4"
      />
      <path d="M245 39.6H227V41.3H245V39.6Z" fill="#231F20" />
      <path d="M253.7 39.6H250V41.3H253.7V39.6Z" fill="#231F20" />
      <path d="M260.8 48.1H236.3V49.8H260.8V48.1Z" fill="#231F20" />
      <path
        d="M509.6 156.4C528.212 156.4 543.3 141.312 543.3 122.7C543.3 104.088 528.212 89 509.6 89C490.988 89 475.9 104.088 475.9 122.7C475.9 141.312 490.988 156.4 509.6 156.4Z"
        fill="#C7D2D4"
      />
      <path
        d="M531.401 132.1L534.901 135.5C536.101 136.7 536.101 138.6 534.901 139.8C533.701 141 531.801 141 530.601 139.8L527.101 136.4C525.901 135.2 525.901 133.3 527.101 132.1C528.301 130.9 530.201 130.9 531.401 132.1Z"
        fill="white"
      />
      <path
        d="M532.701 141.6C531.701 141.6 530.701 141.2 529.901 140.5L526.401 137.1C525.701 136.4 525.201 135.4 525.201 134.3C525.201 133.3 525.601 132.3 526.301 131.5C527.801 130 530.301 129.9 531.801 131.5L535.301 134.9C536.001 135.6 536.501 136.6 536.501 137.7C536.501 138.7 536.101 139.7 535.401 140.5C534.701 141.2 533.701 141.6 532.701 141.6ZM529.301 132.1C528.701 132.1 528.201 132.3 527.701 132.8C527.301 133.2 527.101 133.8 527.101 134.4C527.101 135 527.301 135.6 527.801 136L531.301 139.4C532.201 140.3 533.601 140.2 534.401 139.4C534.801 139 535.001 138.4 535.001 137.8C535.001 137.2 534.801 136.6 534.301 136.2L530.801 132.8C530.401 132.3 529.801 132.1 529.301 132.1Z"
        fill="#231F20"
      />
      <path
        d="M517.163 126.694L521.577 131.048L525.861 126.706L521.447 122.351L517.163 126.694Z"
        fill="white"
      />
      <path
        d="M521.6 132.3L516 126.7L521.5 121.1L527.1 126.7L521.6 132.3ZM518.401 126.7L521.6 129.9L524.701 126.7L521.5 123.5L518.401 126.7Z"
        fill="#231F20"
      />
      <path
        d="M518.571 129.263L530.317 140.851L535.795 135.298L524.049 123.71L518.571 129.263Z"
        fill="#5B5B5B"
      />
      <path
        d="M513.836 122.084L517.822 126.016L520.912 122.884L516.926 118.951L513.836 122.084Z"
        fill="white"
      />
      <path
        d="M517.801 127.3L512.601 122.2L516.901 117.9L522.101 123L517.801 127.3ZM515.001 122.1L517.801 124.8L519.701 122.9L516.901 120.2L515.001 122.1Z"
        fill="#231F20"
      />
      <path
        d="M522.067 128.677L521.084 129.674L529.912 138.382L530.895 137.386L522.067 128.677Z"
        fill="white"
      />
      <path
        d="M497.2 102.6C502.2 97.5 510.4 97.5 515.5 102.5C520.6 107.5 520.6 115.7 515.6 120.8C510.6 125.9 502.4 125.9 497.3 120.9C492.2 115.9 492.2 107.7 497.2 102.6Z"
        fill="white"
      />
      <path
        d="M506.4 125.5C502.7 125.5 499.3 124.1 496.7 121.5C491.3 116.2 491.2 107.4 496.6 102C501.9 96.6 510.7 96.5 516.1 101.9C521.5 107.2 521.6 116 516.2 121.4C513.6 124.1 510.2 125.5 506.4 125.5C506.4 125.5 506.5 125.5 506.4 125.5ZM497.8 103.2C493.1 107.9 493.2 115.6 497.9 120.3C500.2 122.5 503.2 123.8 506.4 123.8H506.5C509.7 123.8 512.8 122.5 515 120.2C519.7 115.4 519.6 107.8 514.9 103.1C510.2 98.4 502.5 98.5 497.8 103.2Z"
        fill="#231F20"
      />
      <path
        d="M499.3 104.7C503.2 100.8 509.5 100.7 513.4 104.6C517.3 108.5 517.4 114.8 513.5 118.7C509.6 122.6 503.3 122.7 499.4 118.8C495.5 115 495.4 108.6 499.3 104.7Z"
        fill="#FEDF0D"
      />
      <path
        d="M500.6 117.6C497.3 114.4 497.3 109.1 500.5 105.9L501.5 106.9C498.8 109.6 498.9 114 501.6 116.7L500.6 117.6Z"
        fill="white"
      />

      <path
        d="M509.401 135.9H503.201C502.801 135.9 502.5 135.6 502.5 135.2C502.5 134.8 502.801 134.5 503.201 134.5H509.401C509.801 134.5 510.1 134.8 510.1 135.2C510 135.6 509.701 135.9 509.401 135.9Z"
        fill="#5B5B5B"
      />
      <path
        d="M511.2 134.4L509.9 135.7C509.6 136 509.2 136 509 135.7C508.7 135.4 508.7 135 509 134.8L510.3 133.5C510.6 133.2 511 133.2 511.2 133.5C511.4 133.7 511.4 134.2 511.2 134.4Z"
        fill="#5B5B5B"
      />
      <path
        d="M511.301 141.3H506.401C506.001 141.3 505.701 141 505.701 140.6C505.701 140.2 506.001 139.9 506.401 139.9H511.301C511.701 139.9 512.001 140.2 512.001 140.6C511.901 141 511.601 141.3 511.301 141.3Z"
        fill="#5B5B5B"
      />
      <path
        d="M509.7 145.1H503.5C503.1 145.1 502.8 145.4 502.8 145.8C502.8 146.2 503.1 146.5 503.5 146.5H509.7C510.1 146.5 510.4 146.2 510.4 145.8C510.3 145.4 510 145.1 509.7 145.1Z"
        fill="#5B5B5B"
      />
      <path
        d="M511.501 146.6L510.201 145.3C509.901 145 509.501 145 509.301 145.3C509.001 145.6 509.001 146 509.301 146.2L510.601 147.5C510.901 147.8 511.301 147.8 511.501 147.5C511.701 147.3 511.701 146.9 511.501 146.6Z"
        fill="#5B5B5B"
      />
      <path
        d="M494.701 135.9H500.901C501.301 135.9 501.6 135.6 501.6 135.2C501.6 134.8 501.301 134.5 500.901 134.5H494.701C494.301 134.5 494 134.8 494 135.2C494 135.6 494.301 135.9 494.701 135.9Z"
        fill="#5B5B5B"
      />
      <path
        d="M492.901 134.4L494.201 135.7C494.501 136 494.901 136 495.101 135.7C495.401 135.4 495.401 135 495.101 134.8L493.801 133.5C493.501 133.2 493.101 133.2 492.901 133.5C492.601 133.7 492.601 134.2 492.901 134.4Z"
        fill="#5B5B5B"
      />
      <path
        d="M492.801 141.3H497.701C498.101 141.3 498.401 141 498.401 140.6C498.401 140.2 498.101 139.9 497.701 139.9H492.801C492.401 139.9 492.101 140.2 492.101 140.6C492.101 141 492.401 141.3 492.801 141.3Z"
        fill="#5B5B5B"
      />
      <path
        d="M494.401 145.1H500.601C501.001 145.1 501.301 145.4 501.301 145.8C501.301 146.2 501.001 146.5 500.601 146.5H494.401C494.001 146.5 493.701 146.2 493.701 145.8C493.701 145.4 494.001 145.1 494.401 145.1Z"
        fill="#5B5B5B"
      />
      <path
        d="M492.6 146.6L493.901 145.3C494.201 145 494.601 145 494.801 145.3C495.101 145.6 495.101 146 494.801 146.2L493.501 147.5C493.201 147.8 492.8 147.8 492.6 147.5C492.3 147.3 492.3 146.9 492.6 146.6Z"
        fill="#5B5B5B"
      />
      <g id={styles.ladybug}>
        <path
          d="M502 129.2C499.8 129.2 497.9 131 497.9 133.3H506C506.1 131 504.3 129.2 502 129.2Z"
          fill="#5B5B5B"
        />
        <path
          d="M505.301 134.6H498.801C496.401 135.8 494.701 138.3 494.701 141.2C494.701 145.2 498.001 148.5 502.001 148.5C506.001 148.5 509.301 145.2 509.301 141.2C509.401 138.3 507.701 135.8 505.301 134.6Z"
          fill="white"
        />
        <path
          d="M502.001 149.4C497.501 149.4 493.801 145.7 493.801 141.2C493.801 138.1 495.501 135.3 498.401 133.9L498.601 133.8H505.501L505.701 133.9C508.501 135.3 510.301 138.1 510.301 141.2C510.201 145.7 506.501 149.4 502.001 149.4ZM499.001 135.5C496.901 136.6 495.601 138.8 495.601 141.2C495.601 144.8 498.501 147.7 502.101 147.7C505.701 147.7 508.601 144.8 508.601 141.2C508.601 138.8 507.301 136.6 505.201 135.5H499.001Z"
          fill="#231F20"
        />
        <path
          d="M498.801 129.5L500.101 130.8C500.401 131.1 500.801 131.1 501.001 130.8C501.301 130.5 501.301 130.1 501.001 129.9L499.701 128.6C499.401 128.3 499.001 128.3 498.801 128.6C498.501 128.9 498.501 129.3 498.801 129.5Z"
          fill="#5B5B5B"
        />
        <path
          d="M505.301 129.5L504.001 130.8C503.701 131.1 503.3 131.1 503.1 130.8C502.8 130.5 502.8 130.1 503.1 129.9L504.401 128.6C504.701 128.3 505.101 128.3 505.301 128.6C505.501 128.9 505.501 129.3 505.301 129.5Z"
          fill="#5B5B5B"
        />
        <path
          d="M501.101 148.4V134.7C501.101 134.3 501.501 134 502.101 134C502.601 134 503.101 134.3 503.101 134.7V148.4C503.101 148.8 502.701 149.1 502.101 149.1C501.501 149.1 501.101 148.8 501.101 148.4Z"
          fill="#231F20"
        />
      </g>
      <path
        d="M626.4 115.2H595.6C593 115.2 590.8 113.1 590.8 110.4V68.3C590.8 65.7 592.9 63.5 595.6 63.5H626.4C629 63.5 631.2 65.6 631.2 68.3V110.4C631.1 113.1 629 115.2 626.4 115.2ZM595.5 65.3C593.8 65.3 592.4 66.7 592.4 68.4V110.5C592.4 112.2 593.8 113.6 595.5 113.6H626.3C628 113.6 629.4 112.2 629.4 110.5V68.4C629.4 66.7 628 65.3 626.3 65.3H595.5Z"
        fill="#231F20"
      />
      <path d="M627.4 67.8H594.4V110.9H627.4V67.8Z" fill="white" />
      <path d="M624 70.9H597.9V107.8H624V70.9Z" fill="white" />
      <path
        d="M624.901 108.7H597V70.1H624.8V108.7H624.901ZM598.701 107H623.1V71.8H598.701V107Z"
        fill="#231F20"
      />
      <path d="M617.7 63.9H604.3V72.6H617.7V63.9Z" fill="#5B5A5A" />
      <path
        d="M618.5 73.4H603.4V63H618.5V73.4ZM605.1 71.7H616.8V64.7H605.1V71.7Z"
        fill="#231F20"
      />
      <path
        d="M614.3 63.9C614.3 65.8 612.801 67.3 610.901 67.3C609.001 67.3 607.5 65.8 607.5 63.9C607.5 62 609.001 60.5 610.901 60.5C612.801 60.5 614.3 62 614.3 63.9Z"
        fill="#5B5A5A"
      />
      <path
        d="M611 68.2C608.7 68.2 606.8 66.3 606.8 64C606.8 61.7 608.7 59.8 611 59.8C613.3 59.8 615.2 61.7 615.2 64C615.2 66.3 613.3 68.2 611 68.2ZM611 61.4C609.6 61.4 608.5 62.5 608.5 63.9C608.5 65.3 609.6 66.4 611 66.4C612.4 66.4 613.5 65.3 613.5 63.9C613.5 62.5 612.4 61.4 611 61.4Z"
        fill="#231F20"
      />
      <path
        d="M603.8 83.9L601.3 81.5L602.4 80.3L603.6 81.3L606.4 77.4L607.8 78.4L603.8 83.9Z"
        fill="#231F20"
      />
      <path d="M620.1 79.4H609V81.1H620.1V79.4Z" fill="#231F20" />
      <path
        d="M603.8 93.1L601.3 90.8L602.4 89.5L603.6 90.6L606.4 86.6L607.8 87.6L603.8 93.1Z"
        fill="#231F20"
      />
      <path d="M620.1 88.6H609V90.3H620.1V88.6Z" fill="#231F20" />
      <path
        d="M603.8 102.2L601.3 99.8L602.4 98.6L603.6 99.6L606.4 95.7L607.8 96.7L603.8 102.2Z"
        fill="#231F20"
      />
      <path d="M620.1 97.7H609V99.4H620.1V97.7Z" fill="#231F20" />
      <path
        d="M535.7 68.5H511.9C509.9 68.5 508.2 70.1 508.2 72.2V84.1C508.2 86.1 509.8 87.8 511.9 87.8H513V94.1L518.5 87.8H535.8C537.8 87.8 539.5 86.2 539.5 84.1V72.2C539.4 70.2 537.8 68.5 535.7 68.5Z"
        fill="#5B5A5A"
      />
      <path d="M533.5 74.3H514.1V75.9H533.5V74.3Z" fill="white" />
      <path d="M533.5 80.2H514.1V81.8H533.5V80.2Z" fill="white" />
      <path
        d="M240.3 156.4L238.8 154.9C238.8 154.9 239.1 154.6 239.3 154.3C239.5 154 239.7 153.6 239.7 153.6L241.6 154.4C241.6 154.4 241.4 154.9 241 155.4C240.7 156 240.3 156.4 240.3 156.4Z"
        fill="#231F20"
      />
      <path
        d="M236 158.2V156C236 156 236.1 156 236.2 156C236.3 156 236.5 156 236.7 155.9C237.1 155.8 237.4 155.7 237.4 155.7L238.2 157.6C238.2 157.6 237.7 157.8 237.1 157.9C236.8 157.9 236.5 158 236.3 158C236.2 158.2 236 158.2 236 158.2Z"
        fill="#231F20"
      />
      <path
        d="M231.8 156.4L233.3 154.9C233.3 154.9 233.6 155.2 233.9 155.4C234.2 155.6 234.6 155.8 234.6 155.8L233.8 157.7C233.8 157.7 233.3 157.5 232.8 157.1C232.2 156.8 231.8 156.4 231.8 156.4Z"
        fill="#231F20"
      />
      <path
        d="M230.1 152.2H232.2C232.2 152.2 232.2 152.3 232.2 152.4C232.2 152.5 232.2 152.7 232.3 152.9C232.4 153.3 232.5 153.6 232.5 153.6L230.6 154.4C230.6 154.4 230.4 153.9 230.3 153.3C230.3 153 230.2 152.7 230.2 152.5C230.1 152.3 230.1 152.2 230.1 152.2Z"
        fill="#231F20"
      />
      <path
        d="M231.8 147.9L233.3 149.4C233.3 149.4 233 149.7 232.8 150C232.6 150.3 232.4 150.7 232.4 150.7L230.5 149.9C230.5 149.9 230.7 149.4 231.1 148.9C231.4 148.4 231.8 147.9 231.8 147.9Z"
        fill="#231F20"
      />
      <path
        d="M236 146.2V148.3C236 148.3 235.9 148.3 235.8 148.3C235.7 148.3 235.5 148.3 235.3 148.4C234.9 148.5 234.6 148.6 234.6 148.6L233.8 146.7C233.8 146.7 234.3 146.5 234.9 146.4C235.2 146.4 235.5 146.3 235.7 146.3C235.9 146.2 236 146.2 236 146.2Z"
        fill="#231F20"
      />
      <path
        d="M240.3 147.9L238.8 149.4C238.8 149.4 238.5 149.1 238.2 148.9C237.9 148.7 237.5 148.5 237.5 148.5L238.3 146.6C238.3 146.6 238.8 146.8 239.3 147.2C239.9 147.5 240.3 147.9 240.3 147.9Z"
        fill="#231F20"
      />
      <path
        d="M242 152.2H239.9C239.9 152.2 239.9 152.1 239.9 152C239.9 151.9 239.9 151.7 239.8 151.5C239.7 151.1 239.6 150.8 239.6 150.8L241.5 150C241.5 150 241.7 150.5 241.8 151.1C241.8 151.4 241.9 151.7 241.9 151.9C242 152 242 152.2 242 152.2Z"
        fill="#231F20"
      />
      <path
        d="M63.3005 182.8L62.5005 181.5C62.5005 181.5 62.6005 181.5 62.7005 181.4C62.8005 181.4 62.8005 181.3 62.9005 181.2C63.0005 181.1 63.0005 181.1 63.1005 181C63.2005 180.9 63.2005 180.9 63.3005 180.8C63.4005 180.7 63.4005 180.7 63.5005 180.6C63.6005 180.5 63.6005 180.4 63.6005 180.4L64.9005 181.2C64.9005 181.2 64.8005 181.3 64.7005 181.5C64.6005 181.6 64.6005 181.7 64.5005 181.8C64.4005 181.9 64.3005 182 64.2005 182.1C64.1005 182.2 64.0005 182.3 63.9005 182.4C63.8005 182.5 63.7005 182.6 63.6005 182.6C63.5005 182.7 63.3005 182.8 63.3005 182.8Z"
        fill="#231F20"
      />
      <path
        d="M58.7002 182.8L59.5002 181.5C59.5002 181.5 59.5002 181.5 59.6002 181.5C59.6002 181.5 59.7002 181.5 59.8002 181.6C59.9002 181.6 59.9002 181.7 60.0002 181.7C60.1002 181.7 60.2002 181.8 60.3002 181.8C60.5002 181.9 60.7002 181.9 60.8002 181.9C61.0002 181.9 61.1002 181.9 61.1002 181.9V183.4C61.1002 183.4 60.9002 183.4 60.7002 183.4C60.5002 183.4 60.2002 183.3 59.9002 183.3C59.8002 183.3 59.6002 183.2 59.5002 183.2C59.4002 183.2 59.2002 183.1 59.1002 183C58.8002 182.8 58.7002 182.8 58.7002 182.8Z"
        fill="#231F20"
      />
      <path
        d="M56.4004 178.8H57.9004C57.9004 178.8 57.9004 178.9 57.9004 179.1C57.9004 179.3 57.9004 179.5 58.0004 179.6C58.0004 179.7 58.1004 179.8 58.1004 179.9C58.1004 180 58.2004 180.1 58.2004 180.1C58.2004 180.2 58.3004 180.2 58.3004 180.3V180.4L57.0004 181.2C57.0004 181.2 56.9004 181.1 56.8004 180.9C56.7004 180.8 56.7004 180.7 56.6004 180.5C56.6004 180.4 56.5004 180.2 56.5004 180.1C56.4004 179.8 56.4004 179.5 56.4004 179.3C56.4004 178.9 56.4004 178.8 56.4004 178.8Z"
        fill="#231F20"
      />
      <path
        d="M58.7006 174.8L59.5006 176.1C59.5006 176.1 59.4006 176.1 59.3006 176.2C59.2006 176.2 59.2006 176.3 59.1006 176.4C59.0006 176.5 59.0006 176.5 58.9006 176.6C58.8006 176.7 58.8006 176.7 58.7006 176.8C58.6006 176.9 58.6006 176.9 58.5006 177C58.4006 177.1 58.4006 177.2 58.4006 177.2L57.1006 176.4C57.1006 176.4 57.2006 176.3 57.3006 176.1C57.4006 176 57.4006 175.9 57.5006 175.8C57.6006 175.7 57.7006 175.6 57.8006 175.5C57.9006 175.4 58.0006 175.3 58.1006 175.2C58.2006 175.1 58.3006 175 58.4006 175C58.6006 174.9 58.7006 174.8 58.7006 174.8Z"
        fill="#231F20"
      />
      <path
        d="M63.3004 174.8L62.5004 176.1C62.5004 176.1 62.5004 176.1 62.4004 176.1C62.4004 176.1 62.3004 176.1 62.2004 176C62.1004 176 62.1004 175.9 62.0004 175.9C61.9004 175.9 61.8004 175.8 61.7004 175.8C61.5004 175.7 61.3004 175.7 61.2004 175.7C61.0004 175.7 60.9004 175.7 60.9004 175.7V174.2C60.9004 174.2 61.1004 174.2 61.3004 174.2C61.5004 174.2 61.8004 174.3 62.1004 174.3C62.2004 174.3 62.4004 174.4 62.5004 174.4C62.6004 174.4 62.8004 174.5 62.9004 174.6C63.2004 174.7 63.3004 174.8 63.3004 174.8Z"
        fill="#231F20"
      />
      <path
        d="M65.6002 178.8H64.1002C64.1002 178.8 64.1002 178.7 64.1002 178.5C64.1002 178.3 64.1002 178.1 64.0002 178C64.0002 177.9 63.9002 177.8 63.9002 177.7C63.9002 177.6 63.8002 177.5 63.8002 177.5C63.8002 177.4 63.7002 177.4 63.7002 177.3V177.2L65.0002 176.4C65.0002 176.4 65.1002 176.5 65.2002 176.7C65.3002 176.8 65.3002 176.9 65.4002 177.1C65.4002 177.2 65.5002 177.4 65.5002 177.5C65.6002 177.8 65.6002 178.1 65.6002 178.3C65.6002 178.6 65.6002 178.8 65.6002 178.8Z"
        fill="#231F20"
      />
      <path
        d="M77.4002 115.2H75.7002V73.8C75.7002 63.8 83.8002 55.7 93.8002 55.7C103.8 55.7 111.9 63.8 111.9 73.8V90H110.2V73.8C110.2 64.8 102.8 57.4 93.8002 57.4C84.8002 57.4 77.4002 64.8 77.4002 73.8V115.2Z"
        fill="#231F20"
      />
      <path
        d="M52.3002 167.5C38.5002 167.5 27.2002 156.2 27.2002 142.4V122.5H28.9002V142.4C28.9002 155.3 39.4002 165.8 52.3002 165.8C65.2002 165.8 75.7002 155.3 75.7002 142.4V114.4H77.4002V142.4C77.4002 156.3 66.2002 167.5 52.3002 167.5Z"
        fill="#231F20"
      />
      <path
        d="M637.7 167.5C623.9 167.5 612.6 156.2 612.6 142.4V122.5H614.3V142.4C614.3 155.3 624.8 165.8 637.7 165.8"
        fill="#231F20"
      />
      <path
        d="M113.6 98.5H108.3V89.6H113.6V98.5ZM110 96.8H111.9V91.3H110V96.8Z"
        fill="#231F20"
      />
      <path
        d="M111 104.9C109.4 104.9 108 103.6 108 101.9H109.7C109.7 102.6 110.3 103.2 111 103.2C111.7 103.2 112.3 102.6 112.3 101.9C112.3 101.2 111.7 100.6 111 100.6H110.1V97.5H111.8V99C113 99.4 113.9 100.5 113.9 101.8C113.9 103.6 112.6 104.9 111 104.9Z"
        fill="#231F20"
      />
      <g id={styles.circle1}>
        <path
          d="M48.9 156.4L43.9 154.5L44.6 150.2C43.6 149.5 42.7 148.6 41.9 147.6L37.8 148.4L35.6 143.6L39.1 141.1C38.9 139.8 38.9 138.6 39 137.3L35.5 135L37.4 130L41.7 130.7C42.3 129.8 43.1 129 43.9 128.3L42.9 124.1L47.7 121.9L50.3 125.2C51.5 125 52.8 124.9 54.1 125L56.4 121.3L61.4 123.2L60.9 127.4C62 128.1 62.9 129 63.7 129.9L67.9 128.9L70.1 133.7L66.8 136.3C67 137.5 67.1 138.8 67 140.1L70.7 142.4L68.8 147.4L64.6 146.9C63.8 148.1 62.8 149.2 61.7 150.1L62.5 154.2L57.7 156.4L55.2 152.9C53.9 153.1 52.7 153.1 51.4 153L48.9 156.4ZM45.8 153.4L48.2 154.3L50.4 151L50.9 151.1C52.3 151.3 53.8 151.3 55.2 151L55.7 150.9L58.1 154.1L60.5 153L59.7 149.1L60.1 148.8C61.4 147.9 62.5 146.7 63.3 145.3L63.6 144.8L67.5 145.3L68.4 142.9L65 140.8L65.1 140.3C65.3 138.9 65.2 137.4 64.9 136L64.8 135.5L67.9 133.1L66.8 130.7L62.9 131.6L62.6 131.2C61.7 130.1 60.6 129.1 59.4 128.3L58.9 128L59.4 124.1L57 123.2L54.9 126.6L54.4 126.5C53 126.3 51.5 126.4 50.1 126.7L49.6 126.8L47.2 123.7L44.8 124.8L45.7 128.7L45.3 129C44.3 129.8 43.4 130.7 42.7 131.8L42.4 132.2L38.5 131.6L37.6 134L40.9 136.2L40.8 136.7C40.6 138.1 40.6 139.6 40.9 141L41 141.5L37.8 143.9L38.9 146.3L42.8 145.5L43.1 145.9C43.9 147.1 45 148.1 46.2 148.9L46.6 149.2L45.8 153.4Z"
          fill="#231F20"
        />
      </g>
      <path
        d="M56.2998 129.6C61.4998 131.5 64.0998 137.2 62.1998 142.4C60.2998 147.6 54.5998 150.2 49.3998 148.3C44.1998 146.4 41.5998 140.7 43.4998 135.5C45.3998 130.3 51.1998 127.7 56.2998 129.6Z"
        fill="#B0BBBD"
      />
      <path
        d="M54.6999 134C57.3999 135 58.7999 138.1 57.7999 140.8C56.7999 143.5 53.6999 144.9 50.9999 143.9C48.2999 142.9 46.8999 139.8 47.8999 137.1C48.8999 134.4 51.9999 133 54.6999 134Z"
        fill="white"
      />
      <path
        d="M52.8998 145.1C52.1998 145.1 51.4998 145 50.7998 144.7C49.2998 144.1 47.9998 143 47.3998 141.5C46.6998 140 46.6998 138.3 47.1998 136.8C48.3998 133.6 51.8998 132 55.0998 133.2C56.5998 133.8 57.8998 134.9 58.4998 136.4C59.1998 137.9 59.1998 139.6 58.6998 141.1C57.6998 143.5 55.2998 145.1 52.8998 145.1ZM52.8998 134.5C51.0998 134.5 49.3998 135.6 48.6998 137.4C48.2998 138.5 48.2998 139.7 48.7998 140.8C49.2998 141.9 50.1998 142.7 51.2998 143.1C53.5998 144 56.1998 142.8 56.9998 140.5C57.3998 139.4 57.3998 138.2 56.8998 137.1C56.3998 136 55.4998 135.2 54.3998 134.8C53.8998 134.6 53.3998 134.5 52.8998 134.5Z"
        fill="#231F20"
      />
      <path
        d="M94.7998 73.5C96.1998 74 96.8998 75.6 96.3998 77C95.8998 78.4 94.2998 79.1 92.8998 78.6C91.4998 78.1 90.7998 76.5 91.2998 75.1C91.7998 73.7 93.3998 73 94.7998 73.5Z"
        fill="#C7D2D4"
      />
      <path
        d="M103.2 79.7C103.2 79.7 103.6 79.8 103.9 79.9C104.3 80 104.6 80 104.6 80C104.6 80 105.2 78.1 105.1 78.1C105.1 78.1 104.7 78 104.4 77.8C104 77.7 103.7 77.6 103.7 77.6C103.7 77.6 103.7 77.5 103.7 77.4C103.7 77.3 103.8 77.1 103.8 76.9C103.8 76.5 103.8 76.1 103.8 76.1H101.5C101.5 76.1 101.5 76.4 101.5 76.7C101.5 76.9 101.4 77.1 101.4 77.3C101.4 77.5 101.3 77.8 101.2 78C101.1 78.2 101.1 78.5 101 78.7C101 78.8 100.9 78.9 100.9 79C100.9 79.1 100.8 79.2 100.8 79.3C100.7 79.5 100.7 79.6 100.6 79.7C100.5 79.8 100.5 79.8 100.5 79.8L102.5 81C102.5 81.1 103.2 79.7 103.2 79.7Z"
        fill="#C7D2D4"
      />
      <path
        d="M100.1 83.9C100.1 83.9 100.4 84.2 100.7 84.4C101 84.6 101.3 84.9 101.3 84.9C101.3 84.9 101.7 84.6 102 84.2C102.3 83.8 102.7 83.5 102.7 83.5C102.7 83.5 102.5 83.2 102.2 82.9C101.9 82.6 101.7 82.3 101.7 82.3C101.7 82.3 101.9 82 102.2 81.7C102.4 81.4 102.6 81 102.6 81L100.6 79.8C100.6 79.8 100.6 79.9 100.5 79.9C100.4 80 100.4 80.1 100.3 80.3C100.2 80.5 100.1 80.6 99.8998 80.8C99.6998 81 99.5998 81.2 99.3998 81.4C99.1998 81.6 98.9998 81.7 98.7998 81.9C98.5998 82 98.3998 82.2 98.2998 82.3C98.0998 82.4 97.9998 82.5 97.8998 82.5C97.7998 82.6 97.7998 82.6 97.7998 82.6L98.9998 84.6C98.9998 84.6 99.2998 84.4 99.6998 84.2C99.7998 84.1 100.1 83.9 100.1 83.9Z"
        fill="#C7D2D4"
      />
      <path
        d="M95.4 85.9C95.4 85.9 95.5 86.3 95.6 86.6C95.7 87 95.9 87.3 95.9 87.3C95.9 87.4 97.8 86.8 97.8 86.8C97.8 86.8 97.7 86.4 97.7 86.1C97.6 85.7 97.5 85.4 97.5 85.4C97.5 85.4 98.9 84.8 98.9 84.7L97.7 82.7C97.7 82.7 97.6 82.7 97.6 82.8C97.5 82.9 97.4 82.9 97.2 83C97.1 83 97 83.1 96.9 83.1C96.8 83.1 96.7 83.2 96.6 83.2C96.4 83.3 96.1 83.4 95.9 83.4C95.7 83.5 95.4 83.5 95.2 83.6C95 83.6 94.7 83.7 94.6 83.7C94.2 83.7 94 83.7 94 83.7V86C94 86 94.4 86 94.8 86C95 86 95.2 86 95.3 85.9C95.3 86 95.4 85.9 95.4 85.9Z"
        fill="#C7D2D4"
      />
      <path
        d="M90.2001 85.4C90.2001 85.4 90.1001 85.8 90.0001 86.1C89.9001 86.5 89.9001 86.8 89.9001 86.8C89.9001 86.8 91.8001 87.4 91.8001 87.3C91.8001 87.3 91.9001 86.9 92.1001 86.6C92.2001 86.2 92.3001 85.9 92.3001 85.9C92.3001 85.9 92.4001 85.9 92.5001 85.9C92.6001 85.9 92.8001 86 93.0001 86C93.4001 86 93.8001 86 93.8001 86V83.7C93.8001 83.7 93.5001 83.7 93.2001 83.7C93.0001 83.7 92.8001 83.6 92.6001 83.6C92.4001 83.6 92.1001 83.5 91.9001 83.4C91.7001 83.3 91.4001 83.3 91.2001 83.2C91.1001 83.2 91.0001 83.1 90.9001 83.1C90.8001 83.1 90.7001 83 90.6001 83C90.4001 82.9 90.3001 82.9 90.2001 82.8C90.1001 82.7 90.1001 82.7 90.1001 82.7L88.9001 84.7C88.8001 84.8 90.2001 85.4 90.2001 85.4Z"
        fill="#C7D2D4"
      />
      <path
        d="M86 82.3C86 82.3 85.7 82.6 85.5 82.9C85.3 83.2 85 83.5 85 83.5C85 83.5 85.3 83.9 85.7 84.2C86.1 84.5 86.4 84.9 86.4 84.9C86.4 84.9 86.7 84.7 87 84.4C87.3 84.1 87.6 83.9 87.6 83.9C87.6 83.9 87.9 84.1 88.2 84.4C88.5 84.6 88.9 84.8 88.9 84.8L90.1 82.8C90.1 82.8 90 82.8 90 82.7C89.9 82.6 89.8 82.6 89.6 82.5C89.4 82.4 89.3 82.3 89.1 82.1C88.9 81.9 88.7 81.8 88.5 81.6C88.3 81.4 88.2 81.2 88 81C87.9 80.8 87.7 80.6 87.6 80.5C87.5 80.3 87.4 80.2 87.4 80.1C87.3 80 87.3 80 87.3 80L85.3 81.2C85.3 81.2 85.5 81.5 85.7 81.9C85.8 82 86 82.3 86 82.3Z"
        fill="#C7D2D4"
      />
      <path
        d="M83.9 77.6C83.9 77.6 83.5 77.7 83.2 77.8C82.8 77.9 82.5 78.1 82.5 78.1C82.4 78.1 83 80 83 80C83 80 83.4 79.9 83.7 79.9C84.1 79.8 84.4 79.7 84.4 79.7C84.4 79.7 85 81.1 85.1 81.1L87.1 79.9C87.1 79.9 87.1 79.8 87 79.8C86.9 79.7 86.9 79.6 86.8 79.4C86.8 79.3 86.7 79.2 86.7 79.1C86.7 79 86.6 78.9 86.6 78.8C86.5 78.6 86.4 78.3 86.4 78.1C86.3 77.9 86.3 77.6 86.2 77.4C86.2 77.2 86.1 76.9 86.1 76.8C86.1 76.4 86.1 76.2 86.1 76.2H83.8C83.8 76.2 83.8 76.6 83.8 77C83.8 77.2 83.8 77.4 83.9 77.5C83.9 77.5 83.9 77.6 83.9 77.6Z"
        fill="#C7D2D4"
      />
      <path
        d="M84.5001 72.4C84.5001 72.4 84.1001 72.3 83.8001 72.2C83.4001 72.1 83.1001 72.1 83.1001 72.1C83.1001 72.1 82.5001 74 82.6001 74C82.6001 74 83.0001 74.1 83.3001 74.3C83.7001 74.4 84.0001 74.5 84.0001 74.5C84.0001 74.5 84.0001 74.6 84.0001 74.7C84.0001 74.8 83.9001 75 83.9001 75.2C83.9001 75.6 83.9001 76 83.9001 76H86.2001C86.2001 76 86.2001 75.7 86.2001 75.4C86.2001 75.2 86.3001 75 86.3001 74.8C86.3001 74.6 86.4001 74.3 86.5001 74.1C86.6001 73.9 86.6001 73.6 86.7001 73.4C86.7001 73.3 86.8001 73.2 86.8001 73.1C86.8001 73 86.9001 72.9 86.9001 72.8C87.0001 72.6 87.0001 72.5 87.1001 72.4C87.2001 72.3 87.2001 72.3 87.2001 72.3L85.2001 71.1C85.1001 71 84.4001 72.4 84.5001 72.4Z"
        fill="#C7D2D4"
      />
      <path
        d="M87.4999 68.2C87.4999 68.2 87.1999 67.9 86.8999 67.7C86.5999 67.5 86.2999 67.2 86.2999 67.2C86.2999 67.2 85.8999 67.5 85.5999 67.9C85.2999 68.3 84.8999 68.6 84.8999 68.6C84.8999 68.6 85.0999 68.9 85.3999 69.2C85.6999 69.5 85.8999 69.8 85.8999 69.8C85.8999 69.8 85.6999 70.1 85.3999 70.4C85.1999 70.7 84.9999 71.1 84.9999 71.1L86.9999 72.3C86.9999 72.3 86.9999 72.2 87.0999 72.2C87.1999 72.1 87.1999 72 87.2999 71.8C87.3999 71.6 87.4999 71.5 87.6999 71.3C87.8999 71.1 87.9999 70.9 88.1999 70.7C88.3999 70.5 88.5999 70.4 88.7999 70.2C88.9999 70.1 89.1999 69.9 89.2999 69.8C89.4999 69.7 89.5999 69.6 89.6999 69.6C89.7999 69.5 89.7999 69.5 89.7999 69.5L88.5999 67.5C88.5999 67.5 88.2999 67.7 87.8999 67.9C87.7999 68 87.4999 68.2 87.4999 68.2Z"
        fill="#C7D2D4"
      />
      <path
        d="M92.2998 66.1C92.2998 66.1 92.1998 65.7 92.0998 65.4C91.9998 65 91.7998 64.7 91.7998 64.7C91.7998 64.6 89.8998 65.2 89.8998 65.2C89.8998 65.2 89.9998 65.6 89.9998 65.9C90.0998 66.3 90.1998 66.6 90.1998 66.6C90.1998 66.6 88.7998 67.2 88.7998 67.3L89.9998 69.3C89.9998 69.3 90.0998 69.3 90.0998 69.2C90.1998 69.1 90.2998 69.1 90.4998 69C90.5998 69 90.6998 68.9 90.7998 68.9C90.8998 68.9 90.9998 68.8 91.0998 68.8C91.2998 68.7 91.5998 68.6 91.7998 68.6C91.9998 68.5 92.2998 68.5 92.4998 68.4C92.6998 68.4 92.9998 68.3 93.0998 68.3C93.4998 68.3 93.6998 68.3 93.6998 68.3V66C93.6998 66 93.2998 66 92.8998 66C92.6998 66 92.4998 66 92.3998 66.1C92.3998 66.1 92.2998 66.1 92.2998 66.1Z"
        fill="#C7D2D4"
      />
      <path
        d="M97.3998 66.7C97.3998 66.7 97.4998 66.3 97.5998 66C97.6998 65.6 97.6998 65.3 97.6998 65.3C97.6998 65.3 95.7998 64.7 95.7998 64.8C95.7998 64.8 95.6998 65.2 95.4998 65.5C95.3998 65.9 95.2998 66.2 95.2998 66.2C95.2998 66.2 95.1998 66.2 95.0998 66.2C94.9998 66.2 94.7998 66.1 94.5998 66.1C94.1998 66.1 93.7998 66.1 93.7998 66.1V68.4C93.7998 68.4 94.0998 68.4 94.3998 68.4C94.5998 68.4 94.7998 68.5 94.9998 68.5C95.1998 68.5 95.4998 68.6 95.6998 68.7C95.8998 68.8 96.1998 68.8 96.3998 68.9C96.4998 68.9 96.5998 69 96.6998 69C96.7998 69 96.8998 69.1 96.9998 69.1C97.1998 69.2 97.2998 69.2 97.3998 69.3C97.4998 69.4 97.4998 69.4 97.4998 69.4L98.6998 67.4C98.8998 67.3 97.4998 66.7 97.3998 66.7Z"
        fill="#C7D2D4"
      />
      <path
        d="M101.6 69.7C101.6 69.7 101.9 69.4 102.1 69.1C102.3 68.8 102.6 68.5 102.6 68.5C102.6 68.5 102.3 68.1 101.9 67.8C101.5 67.5 101.2 67.1 101.2 67.1C101.2 67.1 100.9 67.3 100.6 67.6C100.3 67.9 100 68.1 100 68.1C100 68.1 99.7 67.9 99.4 67.6C99.1 67.4 98.7 67.2 98.7 67.2L97.5 69.2C97.5 69.2 97.6 69.2 97.6 69.3C97.7 69.4 97.8 69.4 98 69.5C98.2 69.6 98.3 69.7 98.5 69.9C98.7 70.1 98.9 70.2 99.1 70.4C99.3 70.6 99.4 70.8 99.6 71C99.7 71.2 99.9 71.4 100 71.5C100.1 71.7 100.2 71.8 100.2 71.9C100.3 72 100.3 72 100.3 72L102.3 70.8C102.3 70.8 102.1 70.5 101.9 70.1C101.9 70.1 101.6 69.7 101.6 69.7Z"
        fill="#C7D2D4"
      />
      <path
        d="M103.7 74.5C103.7 74.5 104.1 74.4 104.4 74.3C104.8 74.2 105.1 74 105.1 74C105.2 74 104.6 72.1 104.6 72.1C104.6 72.1 104.2 72.2 103.9 72.2C103.5 72.3 103.2 72.4 103.2 72.4C103.2 72.4 102.6 71 102.5 71L100.5 72.2C100.5 72.2 100.5 72.3 100.6 72.3C100.7 72.4 100.7 72.5 100.8 72.7C100.8 72.8 100.9 72.9 100.9 73C100.9 73.1 101 73.2 101 73.3C101.1 73.5 101.2 73.8 101.2 74C101.3 74.2 101.3 74.5 101.4 74.7C101.4 74.9 101.5 75.2 101.5 75.3C101.5 75.7 101.5 75.9 101.5 75.9H103.8C103.8 75.9 103.8 75.5 103.8 75.1C103.8 74.9 103.8 74.7 103.7 74.6C103.7 74.6 103.7 74.5 103.7 74.5Z"
        fill="#C7D2D4"
      />
      <path d="M111.8 149.1H110.1V162.1H111.8V149.1Z" fill="#231F20" />
      <path d="M123.6 149.1L130.9 162.1L123.6 149.1Z" fill="white" />
      <path
        d="M124.322 148.659L122.841 149.494L130.162 162.472L131.642 161.637L124.322 148.659Z"
        fill="#231F20"
      />
      <path d="M98.4001 149.1L91.1001 162.1L98.4001 149.1Z" fill="white" />
      <path
        d="M97.6602 148.643L90.3398 161.621L91.8205 162.456L99.1409 149.478L97.6602 148.643Z"
        fill="#231F20"
      />
      <path d="M136.5 110.9H85.5V149.9H136.5V110.9Z" fill="#C7D2D4" />
      <path d="M133 113.9H89V146.6H133V113.9Z" fill="white" />
      <path
        d="M133.8 147.4H88.1001V113H133.8V147.4ZM89.8001 145.7H132.1V114.7H89.8001V145.7Z"
        fill="#231F20"
      />
      <path
        d="M119.4 114.7H102.5V109.2H119.4V114.7ZM104.3 113H117.8V111H104.3V113Z"
        fill="#231F20"
      />
      <path d="M111.8 104H110.1V110.5H111.8V104Z" fill="#231F20" />
      <path d="M128.9 117.9H93.1001V135.9H128.9V117.9Z" fill="#FEDF0D" />
      <path
        d="M120.7 128.3C122.578 128.3 124.1 126.778 124.1 124.9C124.1 123.022 122.578 121.5 120.7 121.5C118.823 121.5 117.3 123.022 117.3 124.9C117.3 126.778 118.823 128.3 120.7 128.3Z"
        fill="white"
      />
      <path
        d="M93.1001 132.3L99.5001 123.5L106 132.3L111 126.4L117.4 135.9H93.1001V132.3Z"
        fill="white"
      />
      <g id={styles.circle3}>
        <path
          d="M632.2 135.5H629.8L629.3 138C628.4 138.2 627.5 138.6 626.7 139.1L624.6 137.8L622.9 139.5L624.3 141.6C623.9 142.3 623.5 143.1 623.3 143.9L620.8 144.4V146.8L623.2 147.4C623.4 148.3 623.7 149.2 624.2 150L622.8 152.1L624.5 153.8L626.6 152.5C627.4 153 628.2 153.4 629.1 153.6L629.6 156.1H632L632.6 153.7C633.5 153.5 634.4 153.2 635.2 152.7L637.3 154.1L639 152.4L637.7 150.3C638.3 149.5 638.7 148.5 638.9 147.5L641.3 146.9V144.5L638.8 144C638.6 143.1 638.2 142.2 637.7 141.4L639 139.3L637.3 137.6L635.2 139C634.4 138.5 633.6 138.2 632.6 138L632.2 135.5Z"
          fill="#C7D2D4"
        />
      </g>
      <path
        d="M631.2 142.6C633 142.6 634.4 144.1 634.4 145.8C634.4 147.6 632.9 149 631.2 149C629.4 149 628 147.5 628 145.8C627.9 144 629.4 142.5 631.2 142.6Z"
        fill="white"
      />
      <path
        d="M387.3 179.5C386 179.5 385 178.4 385 177.2C385 176 386.1 174.9 387.3 174.9V176.6C386.9 176.6 386.7 176.9 386.7 177.2C386.7 177.5 387 177.8 387.3 177.8V179.5Z"
        fill="#231F20"
      />
      <path
        d="M387.1 182.5V180.8C387.5 180.8 387.7 180.5 387.7 180.2C387.7 179.8 387.4 179.6 387.1 179.6V177.9C388.4 177.9 389.4 179 389.4 180.2C389.5 181.4 388.4 182.5 387.1 182.5Z"
        fill="#231F20"
      />
      <path
        d="M387.1 176.5V174.8C387.5 174.8 387.7 174.5 387.7 174.2C387.7 173.8 387.4 173.6 387.1 173.6V171.9C388.4 171.9 389.4 173 389.4 174.2C389.5 175.5 388.4 176.5 387.1 176.5Z"
        fill="#231F20"
      />
      <path
        d="M387.1 170.5V168.8C387.5 168.8 387.7 168.5 387.7 168.2C387.7 167.8 387.4 167.6 387.1 167.6V165.9C388.4 165.9 389.4 167 389.4 168.2C389.5 169.5 388.4 170.5 387.1 170.5Z"
        fill="#231F20"
      />
      <path
        d="M387.1 164.6V162.9C387.5 162.9 387.7 162.6 387.7 162.3C387.7 161.9 387.4 161.7 387.1 161.7V160C388.4 160 389.4 161.1 389.4 162.3C389.5 163.5 388.4 164.6 387.1 164.6Z"
        fill="#231F20"
      />
      <path
        d="M387.3 173.5C386 173.5 385 172.4 385 171.2C385 170 386.1 168.9 387.3 168.9V170.6C386.9 170.6 386.7 170.9 386.7 171.2C386.7 171.6 387 171.8 387.3 171.8V173.5Z"
        fill="#231F20"
      />
      <path
        d="M387.3 167.5C386 167.5 385 166.4 385 165.2C385 164 386.1 162.9 387.3 162.9V164.6C386.9 164.6 386.7 164.9 386.7 165.2C386.7 165.5 387 165.8 387.3 165.8V167.5Z"
        fill="#231F20"
      />
      <path
        d="M455 179.8H453.3V63.3C453.3 52.2 462.3 43.2 473.4 43.2C484.5 43.2 493.5 52.2 493.5 63.3V75.3H491.8V63.3C491.8 53.2 483.6 44.9 473.4 44.9C463.2 44.9 455 53.1 455 63.3V179.8Z"
        fill="#231F20"
      />
      <path
        d="M427.1 222C411.7 222 399.2 209.5 399.2 194.1V171.9H400.9V194.1C400.9 208.5 412.6 220.3 427.1 220.3C441.6 220.3 453.3 208.6 453.3 194.1V93.3H455V194.1C455 209.5 442.5 222 427.1 222Z"
        fill="#231F20"
      />
      <path
        d="M283 222C265.2 222 250.7 207.5 250.7 189.7V140.9H252.4V189.7C252.4 206.6 266.1 220.3 283 220.3C299.9 220.3 313.6 206.6 313.6 189.7V172.1H315.3V189.7C315.3 207.5 300.8 222 283 222Z"
        fill="#231F20"
      />
      <path d="M344.6 115.4H305.7V165.9H344.6V115.4Z" fill="white" />
      <path
        d="M345.4 166.8H304.8V114.6H345.4V166.8ZM306.5 165.1H343.7V116.3H306.5V165.1Z"
        fill="#231F20"
      />
      <path
        d="M336.267 137.648C337.721 131.522 333.933 125.378 327.807 123.924C321.681 122.47 315.536 126.258 314.082 132.384C312.629 138.51 316.416 144.655 322.542 146.108C328.668 147.562 334.813 143.774 336.267 137.648Z"
        fill="#5B5B5B"
      />
      <path
        d="M325.1 150C316.8 150 310.1 143.3 310.1 135C310.1 126.7 316.8 120 325.1 120C333.4 120 340.1 126.7 340.1 135C340.2 143.3 333.4 150 325.1 150ZM325.1 121.6C317.8 121.6 311.8 127.6 311.8 134.9C311.8 142.2 317.8 148.2 325.1 148.2C332.4 148.2 338.4 142.2 338.4 134.9C338.5 127.6 332.5 121.6 325.1 121.6Z"
        fill="#231F20"
      />
      <g id={styles.silhouette}>
        <path
          d="M325.1 138C327.309 138 329.1 136.209 329.1 134C329.1 131.791 327.309 130 325.1 130C322.891 130 321.1 131.791 321.1 134C321.1 136.209 322.891 138 325.1 138Z"
          fill="white"
        />
        <path
          d="M325.1 138.8C322.5 138.8 320.3 136.6 320.3 134C320.3 131.4 322.5 129.2 325.1 129.2C327.7 129.2 329.9 131.4 329.9 134C329.9 136.7 327.8 138.8 325.1 138.8ZM325.1 130.9C323.4 130.9 322 132.3 322 134C322 135.7 323.4 137.1 325.1 137.1C326.8 137.1 328.2 135.7 328.2 134C328.2 132.3 326.9 130.9 325.1 130.9Z"
          fill="#231F20"
        />
        <path
          d="M328 138H325.2H322.4C320.1 138 318.1 139.9 318.1 142.3V142.8C320 144.5 322.5 145.6 325.2 145.6C327.9 145.6 330.4 144.6 332.3 142.8V142.3C332.2 139.9 330.3 138 328 138Z"
          fill="white"
        />
        <path
          d="M325.1 146.4C322.3 146.4 319.5 145.3 317.4 143.4L317.1 143.1V142.2C317.1 139.4 319.4 137.1 322.2 137.1H327.9C330.7 137.1 333 139.4 333 142.2V143.1L332.7 143.4C330.7 145.3 328 146.4 325.1 146.4ZM318.9 142.4C320.7 143.9 322.9 144.7 325.2 144.7C327.5 144.7 329.7 143.9 331.4 142.4V142.3C331.4 140.4 329.9 138.9 328 138.9H322.3C320.4 138.9 318.9 140.4 318.9 142.3V142.4V142.4Z"
          fill="#231F20"
        />
      </g>
      <path d="M328.1 154.1H309.7V155.8H328.1V154.1Z" fill="#5B5B5B" />
      <path d="M339.8 158.9H309.7V160.6H339.8V158.9Z" fill="#B0BBBD" />
      <g id={styles.searchbar}>
        <path d="M266.8 64.8H253.9V73H266.8V64.8Z" fill="#C7D2D4" />
        <path
          d="M267.6 73.9H205.8V64H267.6V73.9ZM207.5 72.2H265.9V65.7H207.5V72.2Z"
          fill="#231F20"
        />
        <path d="M224.2 68.4H210.4V70.1H224.2V68.4Z" fill="#C7D2D4" />
        <path
          d="M259.2 71C258.6 71 257.9 70.8 257.5 70.3C257 69.8 256.8 69.2 256.8 68.6C256.8 67.9 257 67.3 257.5 66.9C258 66.4 258.6 66.2 259.2 66.2C259.9 66.2 260.5 66.4 260.9 66.9C261.4 67.4 261.6 68 261.6 68.6C261.7 69.9 260.6 71 259.2 71ZM259.2 67.4C258.9 67.4 258.6 67.5 258.4 67.7C258.2 67.9 258.1 68.2 258.1 68.5C258.1 68.8 258.2 69.1 258.4 69.3C258.6 69.5 258.9 69.6 259.2 69.6C259.8 69.6 260.3 69.1 260.3 68.4C260.3 68.1 260.2 67.8 260 67.6C259.8 67.5 259.5 67.4 259.2 67.4Z"
          fill="white"
        />
        <path
          d="M260.996 69.263L260.104 70.2082L262.067 72.062L262.959 71.1168L260.996 69.263Z"
          fill="white"
        />
      </g>
      <path d="M275.4 77.4H198.3V134.4H275.4V77.4Z" fill="white" />
      <path
        d="M276.3 135.2H197.5V76.5H276.3V135.2ZM199.1 133.5H274.5V78.2H199.1V133.5Z"
        fill="#231F20"
      />
      <path d="M275.4 77.4H198.3V83.5H275.4V77.4Z" fill="#C7D2D4" />
      <path
        d="M276.3 84.4H197.5V76.6H276.3V84.4ZM199.1 82.7H274.5V78.3H199.1V82.7Z"
        fill="#231F20"
      />
      <path d="M203.5 79.6H200.6V81.3H203.5V79.6Z" fill="white" />
      <path d="M230.2 79.6H227.3V81.3H230.2V79.6Z" fill="white" />
      <path d="M210.4 79.6H205.8V81.3H210.4V79.6Z" fill="white" />
      <path d="M225.1 79.6H220.5V81.3H225.1V79.6Z" fill="white" />
      <path d="M218.3 79.6H212.7V81.3H218.3V79.6Z" fill="white" />
      <path d="M202.8 86.6H200.6V88.3H202.8V86.6Z" fill="#231F20" />
      <path d="M202.8 90.5H200.6V92.2H202.8V90.5Z" fill="#231F20" />
      <path d="M202.8 94.4H200.6V96.1H202.8V94.4Z" fill="#231F20" />
      <path d="M209.2 94.4H207V96.1H209.2V94.4Z" fill="#231F20" />
      <path d="M202.8 98.4H200.6V100.1H202.8V98.4Z" fill="#231F20" />
      <path d="M202.8 102.3H200.6V104H202.8V102.3Z" fill="#231F20" />
      <path d="M202.8 106.3H200.6V108H202.8V106.3Z" fill="#231F20" />
      <path d="M202.8 110.2H200.6V111.9H202.8V110.2Z" fill="#231F20" />
      <path d="M202.8 114.1H200.6V115.8H202.8V114.1Z" fill="#231F20" />
      <path d="M202.8 118.1H200.6V119.8H202.8V118.1Z" fill="#231F20" />
      <path d="M202.8 122H200.6V123.7H202.8V122Z" fill="#231F20" />
      <path d="M209.2 122H207V123.7H209.2V122Z" fill="#231F20" />
      <path d="M202.8 125.9H200.6V127.6H202.8V125.9Z" fill="#231F20" />
      <path d="M202.8 129.9H200.6V131.6H202.8V129.9Z" fill="#231F20" />
      <path d="M216.7 86.6H214.5V88.3H216.7V86.6Z" fill="#231F20" />
      <path d="M213.1 86.6H207V88.3H213.1V86.6Z" fill="#231F20" />
      <path d="M221.1 90.5H207.1V92.2H221.1V90.5Z" fill="#231F20" />
      <path d="M229.8 94.4H227.6V96.1H229.8V94.4Z" fill="#231F20" />
      <path d="M225.2 94.4H210.4V96.1H225.2V94.4Z" fill="#231F20" />
      <path d="M221 98.4H208.8V100.1H221V98.4Z" fill="#231F20" />
      <path d="M212.6 102.3H210.4V104H212.6V102.3Z" fill="#231F20" />
      <path d="M228.7 102.3H225.1V104H228.7V102.3Z" fill="#231F20" />
      <path d="M222.8 102.3H213.9V104H222.8V102.3Z" fill="#231F20" />
      <path d="M242 106.3H215.6V108H242V106.3Z" fill="#231F20" />
      <path d="M217.8 110.2H215.6V111.9H217.8V110.2Z" fill="#231F20" />
      <path d="M230.7 110.2H219.5V111.9H230.7V110.2Z" fill="#231F20" />
      <path d="M212.6 114.1H210.4V115.8H212.6V114.1Z" fill="#231F20" />
      <path d="M218.9 114.1H214.4V115.8H218.9V114.1Z" fill="#231F20" />
      <path d="M224.3 122H211V123.7H224.3V122Z" fill="#231F20" />
      <path d="M234.4 125.9H232.2V127.6H234.4V125.9Z" fill="#231F20" />
      <path d="M230.5 125.9H210.6V127.6H230.5V125.9Z" fill="#231F20" />
      <path d="M228 129.9H225.8V131.6H228V129.9Z" fill="#231F20" />
      <path d="M224.3 129.9H215.6V131.6H224.3V129.9Z" fill="#231F20" />
      <path d="M275.4 83.5H247.1V134.4H275.4V83.5Z" fill="white" />
      <path
        d="M276.3 135.2H246.3V82.6H276.3V135.2ZM248 133.5H274.6V84.3H248V133.5Z"
        fill="#231F20"
      />
      <path d="M268.8 88.2H253.9V112.9H268.8V88.2Z" fill="#FEDF0D" />
      <path
        d="M269.6 113.8H253V87.4H269.6V113.8ZM254.7 112.1H267.9V89.1H254.7V112.1Z"
        fill="#231F20"
      />
      <path d="M255.3 119.9H252.7V121.6H255.3V119.9Z" fill="#C7D2D4" />
      <path d="M269.6 119.9H257.7V121.6H269.6V119.9Z" fill="#C7D2D4" />
      <path d="M255.3 122.9H252.7V124.6H255.3V122.9Z" fill="#C7D2D4" />
      <path d="M269.6 122.9H257.7V124.6H269.6V122.9Z" fill="#C7D2D4" />
      <path d="M255.3 126H252.7V127.7H255.3V126Z" fill="#C7D2D4" />
      <path d="M269.6 126H257.7V127.7H269.6V126Z" fill="#C7D2D4" />
      <path d="M255.3 129.1H252.7V130.8H255.3V129.1Z" fill="#C7D2D4" />
      <path d="M269.6 129.1H257.7V130.8H269.6V129.1Z" fill="#C7D2D4" />
      <path d="M266.3 91.5H256.2V108.4H266.3V91.5Z" fill="white" />
      <path d="M118.2 43.4H116.5V52.6H118.2V43.4Z" fill="#231F20" />
      <path d="M122 47.2H112.8V48.9H122V47.2Z" fill="#231F20" />
      <path
        d="M169.5 51.8V170.1C169.5 183.8 158.4 194.9 144.7 194.9C131 194.9 119.9 183.8 119.9 170.1H130.9C130.9 177.7 137.1 183.9 144.7 183.9C152.3 183.9 158.5 177.7 158.5 170.1V51.8H169.5Z"
        fill="white"
      />
      <path d="M165 58.5H163V63H165V58.5Z" fill="#1D1912" />
      <path d="M165 69.8H163V74.3H165V69.8Z" fill="#1D1912" />
      <path d="M165 81H163V85.5H165V81Z" fill="#1D1912" />
      <path d="M165 92.2H163V96.7H165V92.2Z" fill="#1D1912" />
      <path d="M165 103.4H163V107.9H165V103.4Z" fill="#1D1912" />
      <path d="M165 114.7H163V119.2H165V114.7Z" fill="#1D1912" />
      <path d="M165 125.9H163V130.4H165V125.9Z" fill="#1D1912" />
      <path d="M165 137.1H163V141.6H165V137.1Z" fill="#1D1912" />
      <path d="M165 148.3H163V152.8H165V148.3Z" fill="#1D1912" />
      <path d="M165 159.6H163V164.1H165V159.6Z" fill="#1D1912" />
      <path
        d="M165 170.8V171.5C165 171.9 164.9 172.5 164.8 173.1C164.7 173.7 164.6 174.3 164.5 174.7L164.3 175.3L162.4 174.8L162.6 174.1C162.7 173.7 162.8 173.2 162.9 172.7C163 172.2 163.1 171.7 163.1 171.3V170.5L165 170.8Z"
        fill="#1D1912"
      />
      <path
        d="M161.201 181.8L160.801 182.4C160.501 182.8 160.101 183.3 159.701 183.7C159.301 184.1 158.901 184.6 158.501 184.9L158.001 185.3L156.701 183.8L157.201 183.3C157.501 183 157.901 182.6 158.201 182.3C158.601 181.9 158.901 181.5 159.101 181.2L159.501 180.6L161.201 181.8Z"
        fill="#1D1912"
      />
      <path
        d="M152.101 189L151.401 189.2C151.001 189.4 150.401 189.5 149.801 189.7C149.201 189.9 148.601 190 148.201 190.1L147.601 190.2L147.301 188.2L148.001 188.1C148.401 188.1 148.901 187.9 149.401 187.8C149.901 187.7 150.401 187.5 150.701 187.4L151.401 187.1L152.101 189Z"
        fill="#1D1912"
      />
      <path
        d="M140.9 187.9L140.4 189.8L139.4 189.5C139 189.4 138.5 189.3 138.1 189.1C137.9 189 137.8 189 137.6 188.9C137.2 188.8 136.9 188.6 136.6 188.5L136 188.2L136.9 186.4L137.5 186.7C137.7 186.8 138 186.9 138.3 187C138.5 187.1 138.7 187.1 138.9 187.2C139.3 187.3 139.6 187.4 140 187.5L140.9 187.9Z"
        fill="#1D1912"
      />
      <path
        d="M131.8 182.9L130.3 184.2L129.7 183.6C129.4 183.3 129.1 182.9 128.7 182.4C128 181.5 127.4 180.5 127.4 180.5L129.1 179.5C129.1 179.5 129.6 180.4 130.3 181.2C130.6 181.6 130.9 181.9 131.1 182.2L131.8 182.9Z"
        fill="#1D1912"
      />
      <path
        d="M126.901 173.6L124.901 173.9L124.701 172.9C124.601 172.5 124.601 172 124.601 171.5V171C124.601 170.6 124.601 170.3 124.601 170V169.3H126.601V170C126.601 170.2 126.601 170.6 126.601 170.9V171.5C126.601 171.9 126.701 172.3 126.701 172.6L126.901 173.6Z"
        fill="#1D1912"
      />
      <path
        d="M158.5 52.5C158.5 38.8 169.6 27.7 183.3 27.7C197 27.7 208.1 38.8 208.1 52.5H197.1C197.1 44.9 190.9 38.7 183.3 38.7C175.7 38.7 169.5 44.9 169.5 52.5"
        fill="white"
      />
      <path
        d="M163.201 58.7H164.901H163.201ZM164.901 51.8L163.201 51.7C163.301 49.2 163.801 46.9 164.801 44.6L166.401 45.3C165.501 47.3 165.001 49.5 164.901 51.8ZM199.001 42.9C197.801 41 196.301 39.3 194.501 37.9L195.501 36.6C197.401 38.1 199.101 39.9 200.401 42L199.001 42.9ZM170.101 39.7L168.901 38.5C170.601 36.7 172.601 35.3 174.801 34.3L175.501 35.8C173.501 36.8 171.701 38.1 170.101 39.7ZM188.601 34.9C186.501 34.3 184.201 34 182.001 34.2L181.901 32.5C184.301 32.3 186.801 32.6 189.101 33.3L188.601 34.9Z"
        fill="#231F20"
      />
      <path
        d="M203.401 52.5H201.701C201.701 51.4 201.601 50.3 201.401 49.2L203.101 48.9C203.301 50.1 203.401 51.3 203.401 52.5Z"
        fill="#231F20"
      />
      <path
        d="M553.9 52.5C553.9 38.8 565 27.7 578.7 27.7C592.4 27.7 603.5 38.8 603.5 52.5H592.5C592.5 44.9 586.3 38.7 578.7 38.7C571.1 38.7 564.9 44.9 564.9 52.5"
        fill="white"
      />
      <path
        d="M558.5 58.7H560.201H558.5ZM560.201 51.8L558.5 51.7C558.6 49.2 559.1 46.9 560.1 44.6L561.701 45.3C560.801 47.3 560.301 49.5 560.201 51.8ZM594.3 42.9C593.1 41 591.6 39.3 589.8 37.9L590.8 36.6C592.7 38.1 594.401 39.9 595.701 42L594.3 42.9ZM565.401 39.7L564.201 38.5C565.901 36.7 567.9 35.3 570.1 34.3L570.8 35.8C568.8 36.8 567.001 38.1 565.401 39.7ZM583.901 34.9C581.801 34.3 579.5 34 577.3 34.2L577.201 32.5C579.601 32.3 582.101 32.6 584.401 33.3L583.901 34.9Z"
        fill="#231F20"
      />
      <path
        d="M598.701 52.5H597.001C597.001 51.4 596.901 50.3 596.701 49.2L598.401 48.9C598.601 50.1 598.701 51.3 598.701 52.5Z"
        fill="#231F20"
      />
      <g id={styles.circle2}>
        <path
          d="M357.6 2.89999L354 1.5L351.8 5C350.3 4.8 348.8 4.9 347.3 5.3L344.8 2.2L341.3 3.8L342.2 7.8C341.2 8.6 340.2 9.6 339.5 10.7L335.5 10.1L334.1 13.7L337.4 15.9C337.2 17.4 337.2 18.9 337.5 20.4L334.2 22.8L335.8 26.3L339.7 25.5C340.6 26.7 341.7 27.8 342.9 28.6L342.3 32.6L345.9 34L348.1 30.7C349.6 30.9 351.1 30.9 352.6 30.6L355 33.9L358.5 32.3L357.7 28.4C359 27.4 360.2 26.2 361.1 24.8L365.1 25.3L366.5 21.7L363 19.5C363.2 18 363.1 16.5 362.7 15L365.8 12.5L364.2 9L360.2 9.89999C359.3 8.69999 358.2 7.69999 356.9 6.89999L357.6 2.89999Z"
          fill="white"
        />
        <path
          d="M346.4 35.1L341.5 33.3L342.1 29.1C341.1 28.4 340.2 27.5 339.4 26.5L335.3 27.3L333.1 22.5L336.5 20C336.3 18.8 336.3 17.5 336.4 16.3L333 14L334.8 9.10001L339 9.7C339.6 8.8 340.4 8.09999 341.2 7.39999L340.2 3.3L345 1.10001L347.6 4.39999C348.8 4.19999 350.1 4.1 351.3 4.2L353.5 0.600006L358.4 2.39999L357.9 6.5C358.9 7.2 359.9 8 360.7 9L364.8 8L367 12.8L363.7 15.4C363.9 16.6 364 17.9 363.9 19.1L367.5 21.3L365.7 26.2L361.6 25.7C360.8 26.9 359.8 27.9 358.7 28.8L359.5 32.9L354.7 35.1L352.2 31.7C351 31.9 349.7 31.9 348.5 31.8L346.4 35.1ZM343.4 32.1L345.8 33L348 29.8L348.5 29.9C349.9 30.1 351.3 30.1 352.7 29.8L353.2 29.7L355.5 32.9L357.8 31.9L357 28L357.4 27.7C358.7 26.8 359.7 25.6 360.6 24.3L360.9 23.8L364.7 24.3L365.6 21.9L362.3 19.8L362.4 19.3C362.6 17.9 362.5 16.5 362.2 15.1L362.1 14.6L365.1 12.2L364.1 9.89999L360.3 10.8L360 10.4C359.1 9.29999 358.1 8.30001 356.9 7.60001L356.4 7.3L356.9 3.5L354.5 2.60001L352.4 5.89999L351.9 5.8C350.5 5.6 349.1 5.7 347.7 6L347.2 6.10001L344.8 3.10001L342.5 4.10001L343.4 7.89999L343 8.2C342 9 341.2 9.89999 340.5 10.9L340.2 11.3L336.3 10.7L335.4 13.1L338.6 15.3L338.5 15.8C338.3 17.2 338.3 18.6 338.6 20L338.7 20.5L335.5 22.8L336.5 25.1L340.3 24.4L340.6 24.8C341.4 25.9 342.4 26.9 343.6 27.7L344 28L343.4 32.1Z"
          fill="#231F20"
        />
      </g>
      <path
        d="M353.4 9.80001C357.8 11.4 360.1 16.4 358.5 20.8C356.9 25.2 351.9 27.5 347.5 25.9C343.1 24.3 340.8 19.3 342.4 14.9C344 10.4 348.9 8.10001 353.4 9.80001Z"
        fill="#7F8080"
      />
      <path
        d="M347.2 21.3L343.3 17.8L347.2 14.1L348.4 15.3L345.8 17.8L348.3 20L347.2 21.3Z"
        fill="white"
      />
      <path
        d="M353.5 21.3L352.4 20L354.9 17.8L352.3 15.3L353.5 14.1L357.4 17.8L353.5 21.3Z"
        fill="white"
      />
      <path
        d="M350.345 12.9525L348.136 21.8829L349.786 22.2911L351.995 13.3607L350.345 12.9525Z"
        fill="white"
      />
      <path
        d="M307.069 206.37C310.17 193.086 301.915 179.803 288.631 176.702C275.347 173.602 262.064 181.857 258.963 195.141C255.863 208.425 264.118 221.708 277.402 224.808C290.686 227.909 303.968 219.654 307.069 206.37Z"
        fill="#C7D2D4"
      />
      <path
        d="M274.5 197.7V192.2H276.201V189.3H269.701V192.2H271.4V197.7C267.2 198.4 264 202.1 264 206.5C264 211.4 268 215.4 272.9 215.4C277.8 215.4 281.8 211.4 281.8 206.5C281.9 202 278.7 198.4 274.5 197.7Z"
        fill="white"
      />
      <path
        d="M273 216.2C267.6 216.2 263.3 211.8 263.3 206.5C263.3 202 266.4 198.1 270.7 197.1V193.1H269V188.5H277.2V193.1H275.5V197.1C279.8 198.2 282.9 202 282.9 206.5C282.8 211.8 278.4 216.2 273 216.2ZM270.6 191.3H272.3V198.4L271.6 198.5C267.7 199.2 264.9 202.5 264.9 206.4C264.9 210.8 268.5 214.4 272.9 214.4C277.3 214.4 280.9 210.8 280.9 206.4C280.9 202.5 278.1 199.2 274.2 198.5L273.5 198.4V191.3H275.2V190.1H270.4V191.3H270.6Z"
        fill="#231F20"
      />
      <path
        d="M266.5 206.9C266.7 210.3 269.5 213 273 213C276.4 213 279.2 210.3 279.5 206.9H266.5Z"
        fill="#7F8080"
      />
      <path
        d="M300.7 213.9L294.8 203.7V196.7H295.9V194.1H289.8V196.7H290.9V203.7L285 213.9C284.6 214.5 285.1 215.3 285.8 215.3H299.8C300.6 215.3 301.1 214.5 300.7 213.9Z"
        fill="white"
      />
      <path
        d="M299.9 216.2H285.9C285.2 216.2 284.7 215.9 284.3 215.3C284 214.7 284 214.1 284.3 213.5L290.1 203.5V197.6H289V193.3H296.8V197.6H295.7V203.5L301.5 213.5C301.8 214.1 301.8 214.7 301.5 215.3C301.1 215.8 300.5 216.2 299.9 216.2ZM290.6 195.8H291.7V203.9L285.7 214.3V214.4C285.7 214.5 285.8 214.5 285.8 214.5H299.8C299.8 214.5 299.9 214.5 299.9 214.4C299.9 214.3 299.9 214.3 299.9 214.3L293.9 203.9V195.8H295V195H290.6V195.8V195.8Z"
        fill="#231F20"
      />
      <path d="M288.3 213.3L292.8 205.3L297.4 213.3H288.3Z" fill="#FCBF44" />
      <g id={styles.chemistry}>
        <path
          d="M280.4 186H278.7V174C278.7 172.6 277.5 171.4 276.1 171.4C274.7 171.4 273.5 172.6 273.5 174V186H271.8V174C271.8 171.6 273.7 169.7 276.1 169.7C278.5 169.7 280.4 171.6 280.4 174V186Z"
          fill="#231F20"
        />
        <path
          d="M293.9 191.2H292.2V179.6C292.2 178 290.9 176.8 289.4 176.8C287.8 176.8 286.6 178.1 286.6 179.6V185.1H284.9V179.6C284.9 177.1 286.9 175.1 289.4 175.1C291.9 175.1 293.9 177.1 293.9 179.6V191.2Z"
          fill="#231F20"
        />
        <path
          d="M282.6 190.1C280.4 190.1 278.7 188.3 278.7 186.2V174.3H280.4V186.2C280.4 187.4 281.4 188.4 282.6 188.4C283.8 188.4 284.8 187.4 284.8 186.2V183.9H286.5V186.2C286.6 188.4 284.8 190.1 282.6 190.1Z"
          fill="#231F20"
        />
        <path
          d="M293.8 171.1L293.2 170C293.2 170 293.3 170 293.4 169.9C293.4 169.9 293.5 169.8 293.6 169.8C293.7 169.7 293.7 169.7 293.8 169.6C293.9 169.5 293.9 169.5 294 169.4C294 169.3 294.1 169.3 294.1 169.2C294.2 169.1 294.2 169 294.2 169L295.3 169.6C295.3 169.6 295.2 169.7 295.1 169.9C295 170 295 170.1 294.9 170.1C294.8 170.2 294.7 170.3 294.7 170.4C294.6 170.5 294.5 170.6 294.4 170.6C294.3 170.7 294.2 170.7 294.2 170.8C293.9 171.1 293.8 171.1 293.8 171.1Z"
          fill="#231F20"
        />
        <path
          d="M290.1 171.1L290.7 170C290.7 170 290.8 170 290.8 170.1C290.9 170.1 290.9 170.2 291 170.2C291.1 170.2 291.1 170.3 291.2 170.3C291.4 170.3 291.5 170.4 291.6 170.4C291.7 170.4 291.8 170.4 291.8 170.4V171.6C291.8 171.6 291.7 171.6 291.5 171.6C291.3 171.6 291.1 171.6 290.8 171.5C290.7 171.5 290.6 171.4 290.5 171.4C290.4 171.4 290.3 171.3 290.2 171.3C290.2 171.2 290.1 171.1 290.1 171.1Z"
          fill="#231F20"
        />
        <path
          d="M288.3 168H289.5C289.5 168 289.5 168.1 289.5 168.2C289.5 168.3 289.5 168.5 289.6 168.6C289.6 168.7 289.6 168.8 289.7 168.8C289.7 168.9 289.8 168.9 289.8 169C289.8 169.1 289.8 169.1 289.9 169.1L288.8 169.7C288.8 169.7 288.7 169.6 288.7 169.4C288.7 169.3 288.6 169.2 288.6 169.1C288.6 169 288.5 168.9 288.5 168.8C288.4 168.6 288.4 168.3 288.4 168.1C288.3 168.1 288.3 168 288.3 168Z"
          fill="#231F20"
        />
        <path
          d="M290.1 164.8L290.7 165.9C290.7 165.9 290.6 165.9 290.5 166C290.5 166 290.4 166.1 290.3 166.1C290.2 166.2 290.2 166.2 290.1 166.3C290 166.4 290 166.4 289.9 166.5C289.9 166.6 289.8 166.6 289.8 166.7C289.7 166.8 289.7 166.9 289.7 166.9L288.6 166.3C288.6 166.3 288.7 166.2 288.8 166C288.9 165.9 288.9 165.8 289 165.8C289.1 165.7 289.2 165.6 289.2 165.5C289.3 165.4 289.4 165.3 289.5 165.3C289.6 165.2 289.7 165.2 289.7 165.1C290 164.8 290.1 164.8 290.1 164.8Z"
          fill="#231F20"
        />
        <path
          d="M293.8 164.8L293.2 165.9C293.2 165.9 293.1 165.9 293.1 165.8C293 165.8 293 165.7 292.9 165.7C292.8 165.7 292.8 165.6 292.7 165.6C292.5 165.6 292.4 165.5 292.3 165.5C292.2 165.5 292.1 165.5 292.1 165.5V164.3C292.1 164.3 292.2 164.3 292.4 164.3C292.6 164.3 292.8 164.3 293.1 164.4C293.2 164.4 293.3 164.5 293.4 164.5C293.5 164.5 293.6 164.6 293.7 164.6C293.7 164.7 293.8 164.8 293.8 164.8Z"
          fill="#231F20"
        />
        <path
          d="M295.6 168H294.4C294.4 168 294.4 167.9 294.4 167.8C294.4 167.7 294.4 167.5 294.3 167.4C294.3 167.3 294.301 167.2 294.201 167.2C294.201 167.1 294.1 167.1 294.1 167C294.1 166.9 294.1 166.9 294 166.9L295.1 166.3C295.1 166.3 295.201 166.4 295.201 166.6C295.201 166.7 295.3 166.8 295.3 166.9C295.3 167 295.4 167.1 295.4 167.2C295.5 167.4 295.5 167.7 295.5 167.9C295.6 167.8 295.6 168 295.6 168Z"
          fill="#231F20"
        />
      </g>
      <g id={styles.hearts}>
        <path
          d="M600.2 5.89999C598.7 5.89999 597.4 6.69999 596.7 7.89999C596 6.69999 594.7 5.89999 593.2 5.89999C590.9 5.89999 589.3 7.7 589.3 10.3C589.3 12.7 591 14.1 593.8 16.4C594.6 17 595.4 17.7 596.4 18.5L596.7 18.7L597 18.5C598 17.7 598.8 17 599.6 16.4C602.4 14.1 604.1 12.8 604.1 10.3C604.1 7.7 602.5 5.89999 600.2 5.89999Z"
          stroke="#020203"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M556.2 26.8C555.6 26.8 555 27.1 554.7 27.7C554.4 27.2 553.8 26.8 553.2 26.8C552.2 26.8 551.5 27.6 551.5 28.7C551.5 29.8 552.3 30.4 553.5 31.3C553.8 31.6 554.2 31.9 554.6 32.2L554.7 32.3L554.8 32.2C555.2 31.8 555.6 31.5 555.9 31.3C557.1 30.3 557.9 29.7 557.9 28.7C557.9 27.6 557.2 26.8 556.2 26.8Z"
          fill="#020203"
        />
      </g>
      <path
        d="M594.396 35.5045C595.816 26.7829 589.898 18.5607 581.176 17.1397C572.455 15.7188 564.232 21.6373 562.812 30.3589C561.391 39.0806 567.309 47.3028 576.031 48.7237C584.752 50.1447 592.975 44.2262 594.396 35.5045Z"
        fill="#C7D2D4"
      />
      <path
        d="M578.6 50.1C569.1 50.1 561.4 42.4 561.4 32.9C561.4 23.4 569.1 15.7 578.6 15.7C588.1 15.7 595.8 23.4 595.8 32.9C595.8 42.4 588.1 50.1 578.6 50.1ZM578.6 17.7C570.2 17.7 563.4 24.5 563.4 32.9C563.4 41.3 570.2 48.1 578.6 48.1C587 48.1 593.8 41.3 593.8 32.9C593.8 24.5 587 17.7 578.6 17.7Z"
        fill="#231E21"
      />
      <path
        d="M583.2 31.9C583.2 29.4 581.2 27.4 578.7 27.4C576.2 27.4 574.2 29.4 574.2 31.9C574.2 34.4 576.2 36.4 578.7 36.4C581.2 36.4 583.2 34.3 583.2 31.9Z"
        fill="white"
      />
      <path
        d="M578.6 37.4C575.6 37.4 573.1 34.9 573.1 31.9C573.1 28.9 575.6 26.4 578.6 26.4C581.6 26.4 584.1 28.9 584.1 31.9C584.2 34.9 581.7 37.4 578.6 37.4ZM578.6 28.3C576.7 28.3 575.1 29.9 575.1 31.8C575.1 33.7 576.7 35.3 578.6 35.3C580.5 35.3 582.1 33.7 582.1 31.8C582.2 29.9 580.6 28.3 578.6 28.3Z"
        fill="#231E21"
      />
      <path
        d="M581.9 36.4H578.7H575.5C572.8 36.4 570.6 38.6 570.6 41.3V41.9C572.7 43.8 575.6 45 578.7 45C581.8 45 584.7 43.8 586.8 41.9V41.3C586.7 38.6 584.6 36.4 581.9 36.4Z"
        fill="white"
      />
      <path
        d="M578.6 46C575.4 46 572.2 44.8 569.8 42.6L569.5 42.3V41.2C569.5 38 572.1 35.3 575.4 35.3H581.9C585.1 35.3 587.8 37.9 587.8 41.2V42.3L587.5 42.6C585 44.8 581.9 46 578.6 46ZM571.5 41.4C573.5 43.1 576 44 578.6 44C581.2 44 583.7 43.1 585.7 41.4V41.2C585.7 39.1 584 37.3 581.8 37.3H575.3C573.2 37.3 571.4 39 571.4 41.2V41.4H571.5Z"
        fill="#231E21"
      />
      <path
        d="M441.45 199.66C444.892 191.401 440.986 181.917 432.727 178.476C424.468 175.035 414.983 178.94 411.542 187.199C408.101 195.458 412.007 204.943 420.266 208.384C428.525 211.825 438.009 207.919 441.45 199.66Z"
        fill="white"
      />
      <path
        d="M426.5 210.5C417.1 210.5 409.4 202.8 409.4 193.4C409.4 184 417.1 176.3 426.5 176.3C435.9 176.3 443.6 184 443.6 193.4C443.6 202.9 435.9 210.5 426.5 210.5ZM426.5 178C418 178 411.1 184.9 411.1 193.4C411.1 201.9 418 208.8 426.5 208.8C435 208.8 441.9 201.9 441.9 193.4C441.9 184.9 435 178 426.5 178Z"
        fill="#231F20"
      />
      <path
        d="M437.1 193.4C437.1 187.5 432.3 182.8 426.5 182.8V181.1C433.3 181.1 438.8 186.6 438.8 193.4H437.1Z"
        fill="#FEDF0D"
      />
      <path
        d="M436.11 197.998L435.259 199.47L436.818 200.371L437.668 198.899L436.11 197.998Z"
        fill="#231F20"
      />
      <path
        d="M432.534 202.186L431.062 203.037L431.963 204.595L433.435 203.744L432.534 202.186Z"
        fill="#231F20"
      />
      <path
        d="M425.623 204.004L425.621 205.804L427.321 205.806L427.323 204.006L425.623 204.004Z"
        fill="#231F20"
      />
      <path
        d="M420.515 202.113L419.614 203.671L421.085 204.522L421.987 202.964L420.515 202.113Z"
        fill="#231F20"
      />
      <path
        d="M416.949 197.996L415.391 198.897L416.242 200.368L417.8 199.467L416.949 197.996Z"
        fill="#231F20"
      />
      <path
        d="M414.125 192.572L414.124 194.272L415.924 194.274L415.925 192.574L414.125 192.572Z"
        fill="#231F20"
      />
      <path
        d="M416.204 186.549L415.354 188.02L416.912 188.921L417.763 187.449L416.204 186.549Z"
        fill="#231F20"
      />
      <path
        d="M421.027 182.303L419.555 183.154L420.456 184.712L421.928 183.861L421.027 182.303Z"
        fill="#231F20"
      />
      <path
        d="M425.657 181.075L425.655 182.875L427.355 182.877L427.357 181.077L425.657 181.075Z"
        fill="#231F20"
      />
      <path
        d="M431.95 182.198L431.049 183.757L432.521 184.608L433.422 183.049L431.95 182.198Z"
        fill="#231F20"
      />
      <path
        d="M436.837 186.47L435.278 187.371L436.129 188.843L437.688 187.942L436.837 186.47Z"
        fill="#231F20"
      />
      <path
        d="M437.055 192.606L437.053 194.306L438.853 194.308L438.855 192.608L437.055 192.606Z"
        fill="#231F20"
      />
      <path
        d="M428.8 174H424.1C423.2 174 422.4 173.2 422.4 172.3V169.9C422.4 169 423.2 168.2 424.1 168.2H428.8C429.7 168.2 430.5 169 430.5 169.9V172.3C430.5 173.3 429.8 174 428.8 174Z"
        fill="#231F20"
      />
      <path d="M427.4 174H425.7V177.2H427.4V174Z" fill="#231F20" />
      <path
        d="M439.5 180.9L438.1 179.9L439.3 178.3L436.7 176.3L435.5 177.8L434.1 176.8L435.3 175.3C435.9 174.6 436.9 174.4 437.7 175L440.3 177C441 177.6 441.2 178.6 440.6 179.4L439.5 180.9Z"
        fill="#231F20"
      />
      <path
        d="M426.6 195.6C425.3 195.6 424.2 194.5 424.2 193.2C424.2 191.9 425.3 190.8 426.6 190.8C427.9 190.8 429 191.9 429 193.2C429 194.5 427.9 195.6 426.6 195.6ZM426.6 192.6C426.2 192.6 425.9 192.9 425.9 193.3C425.9 193.7 426.2 194 426.6 194C427 194 427.3 193.7 427.3 193.3C427.3 192.9 427 192.6 426.6 192.6Z"
        fill="#231F20"
      />
      <path
        d="M432.226 186.441L427.489 191.178L428.691 192.381L433.428 187.643L432.226 186.441Z"
        fill="#231F20"
      />
    </svg>
  );
};

export default Illustration;
